import dayjs from 'dayjs';
import autoTable from 'jspdf-autotable';
import ReportCoreMixin from '@shared/mixin/report/report.core.mixin.js';
import {benchmark_score, business_site_category} from '@shared/mixin/report/raw-data/hyundai-2025';

const HYUNDAILogoPNG = require('@shared/assets/img/hyundai_logo.png');
const HYUNDAILogoBluePNG = require('@shared/assets/img/hyundai_logo_blue.png');

export default {
    mixins: [ReportCoreMixin],
    data() {
        return {
            category2_score_standard: 50,
            hyundai_colors: {
                blue: '#002c5f',
                sand: '#e4dcd3',
                light_sand: '#f6f3f2',
                gold: '#a36b4f',
                gray: '#b1b1b1',
                muted: '#969696',
            },
            hyundai_colors_rgb: {
                blue: [0, 44, 95],
                sand: [228, 220, 221],
                light_sand: [246, 243, 242],
                gold: [163, 107, 79],
                muted: [150, 150, 150]
            },
            hyundai_logo_white: {
                width: 235 / 4, height: 30 / 4
            },
            hyundai_logo_blue: {
                width: 33.8 * 2, height: 23.9 * 2
            },
            mapSubCodeToScoringPd: {},
            mapSubCodeToSubScoringPd: {},
            
            workerPieChartInstance: null,
            subsCompositionPieChartInstance: null,
            imporanceCompositionPieChartInstance: null,
            category1AreaChartInstance: null,
            category1PieChartInstance: null,
            category1ContraryAreaChartInstance: null,
            category2ContraryAreaChartInstance: null,
            importance_composition_colors: [[69, 90, 100, 1], [96, 125, 139, 1], [144, 164, 174, 1],]
            // category1AreaChartInstance: null
        };
    }, computed: {
        category1_composition_colors() {
            return [this.hyundai_colors_rgb.blue, this.hyundai_colors_rgb.sand];
        },
        hyundai_logo_png() {
            return HYUNDAILogoPNG;
        },
        hyundai_logo_blue_png() {
            return HYUNDAILogoBluePNG;
        },
        benchMarkScore() {
            return benchmark_score;
        },
        businessSiteCategory() {
            return business_site_category;
        },
        _jsPDF_headerStyles() {
            return {
                fontSize: 8.5, fillColor: [152, 74, 89], textColor: [255, 255, 255]
            };
        },
        _jsPDF_font_config_fontSize() {
            if (this.report_lang === 'en') {
                return {
                    cover_name_lg: 35,
                    cover_name: 30,
                    cover_company_name: 25,
                    title: 13.5, // 15,
                    title_sm: 12, // 13,
                    title_xs: 10.5, // 11,
                    table_th: 9.5, // 9,
                    table_td: 8.5, // 8,
                    footnote: 8, // 9,
                    default: 9, // 7,
                };
            } else {
                return {
                    cover_name_lg: 50,
                    cover_name: 30,
                    cover_company_name: 25,
                    title: 15,
                    title_sm: 13,
                    title_xs: 11,
                    table_th: 9,
                    table_td: 8,
                    footnote: 9,
                    default: 7
                };
            }
        },
        tableStyles() {
            return {
                global: {
                    valign: 'middle',
                    overflow: 'linebreak',
                    lineColor: [222, 226, 230],
                    lineWidth: 0.1,
                    minCellHeight: 16,
                }, th: {
                    // fontSize: this.report_lang === "ko" ? 11 : 10,
                    // fontSize: this.report_lang === "ko" ? 11 : 10.5,
                    fontSize: this.report_lang === 'ko' ? 9.5 : 9,
                    font: this.report_lang !== 'ca' ? 'NotoSansKR' : 'NotoSansHK',
                    cellPadding: {top: 4, bottom: 3, left: 3, right: 4},
                    fontStyle: 'medium',
                    fillColor: [246, 243, 242],
                    lineColor: [228, 220, 211],
                    textColor: '#292828', // "#424242"
                    valign: 'middle'
                }, td: {
                    font: this.report_lang !== 'ca' ? 'NotoSansKR' : 'NotoSansHK', // fontSize: this.report_lang === "ko" ? 9.5 : 9.0,
                    // fontSize: this.report_lang === "ko" ? 9.5 : 9,
                    fontSize: this.report_lang === 'ko' ? 8.5 : 8,
                    cellPadding: {top: 4, bottom: 3, left: 3, right: 4},
                    fontStyle: 'normal',
                    fillColor: '#FFFFFF', // [256, 256, 256],
                    // textColor: "#424242", // "#616161",
                    valign: 'middle'
                }
            };
        }, _jsPDF_card_config() {
            return {
                fillColor: [246, 243, 242], // '#F8F8F8',
                borderColor: '#e4dcd3', // '#E0E0E0',
                lineWidth: 0.5
            };
        },
        headerInfo() {
            return {
                request_id: this.reportData?.info?.id,
                company_id: this.reportData?.info?.company.id,
                company_name: this.reportData?.info?.company?.company_name,
                vendor_code: this.reportData?.info?.vendor_code,
                published_date: this.reportData?.info?.completed_ts
            };
        },
        project_code(){
            return this.reportData?.info?.project_code;
        },
        category1_description() {
            return {
                '1. 인권 및 노동': this.$t('인권 및 노동 영역 평가는 각 법인이 인권 및 노동 관련 리스크를 적절히 관리하고, 인권경영 시스템을 체계적으로 구축하였는지, 근로환경 개선을 위한 실질적인 활동을 수행하며, 공급망과 생활환경에 대한 관리가 적정하게 이루어지고 있는지를 종합적으로 확인합니다.', this.report_lang),
                '2. 윤리': this.$t('윤리 영역 평가는 각 법인이 윤리적 경영체계를 구축하여 부패, 뇌물 수수 등 비윤리적 행위에 대한 관리·감독을 적절히 수행하고 있는지, 아울러 그린워싱 리스크의 발생을 방지하기 위한 예방적 조치를 이행하고 있는지를 확인합니다.', this.report_lang),
            };
        },
        scoringInfo() {
            let _total_score = this.scoring.total_scoring_pd[0];
            _total_score['환산_점수'] = this.roundToOneDecimalPlace(_total_score['환산_점수']);
            
            let _category1_score = [];
            if (this.scoring?.category1_scoring_pd) {
                _category1_score = this.orderCategory1(this.scoring?.category1_scoring_pd, 'category1_question_name').reduce((_category1_score, _category1) => {
                    const _question_name = this.report_lang === 'ko' ? _category1['category1_question_name'] : this.report_lang === 'en' ? _category1['category1_question_name_ea'] : _category1['category1_question_name_ca'];
                    
                    _category1_score.push({
                        question_name: _question_name,
                        question_name_ko: _category1['category1_question_name'],
                        '문항_수': _category1['문항 수'] || 0,
                        '배점': _category1['배점'] || 0,
                        '배점_대비_점수_백분율': _category1['배점_대비_점수_백분율'] || 0,
                        '배점_합': _category1['배점_합'] || 0,
                        '가중치': this.roundToOneDecimalPlace(_category1['가중치'] || 0),
                        '접수_합': this.roundToOneDecimalPlace(_category1['score'] || 0),
                        '환산_점수': this.roundToOneDecimalPlace(_category1['환산_점수'] || 0)
                    });
                    return _category1_score;
                }, []);
            }
            
            let _category2_score = [];
            if (this.scoring?.category2_scoring_pd) {
                this.scoring?.category2_scoring_pd.sort((a, b) => {
                    const min = Number(a.category2_question_name.substring(0, 3).split('.').join(''));
                    const max = Number(b.category2_question_name.substring(0, 3).split('.').join(''));
                    return min - max;
                });
                _category2_score = this.scoring?.category2_scoring_pd.reduce((_category2_score, _category2) => {
                    const _question_name = this.report_lang === 'ko' ? _category2['category2_question_name'] : this.report_lang === 'en' ? _category2['category2_question_name_ea'] : _category2['category2_question_name_ca'];
                    
                    _category2_score.push({
                        question_name: _question_name,
                        question_name_ko: _category2['category2_question_name'],
                        '문항_수': _category2['문항 수'] || 0,
                        '배점': _category2['배점'] || 0,
                        '배점_대비_점수_백분율': _category2['배점_대비_점수_백분율'] || 0,
                        '배점_합': _category2['배점_합'] || 0,
                        '가중치': this.roundToOneDecimalPlace(_category2['가중치'] || 0),
                        '점수_합': this.roundToOneDecimalPlace(_category2['score'] || 0),
                        '환산_점수': this.roundToOneDecimalPlace(_category2['환산_점수'] || 0)
                    });
                    return _category2_score;
                }, []);
            }
            
            let _category3_score = [];
            if (this.scoring?.category3_scoring_pd) {
                _category3_score = this.scoring?.category3_scoring_pd.reduce((_category3_score, _category3) => {
                    const _category3_sub_scoring = this.scoring.sub_scoring_pd.filter((_category3_sub) => _category3_sub.category3_question_code === _category3.category3_question_code);
                    
                    let _is_category3_na = false;
                    if (_category3_sub_scoring.length) {
                        _is_category3_na = _category3_sub_scoring.every(({not_applicable}) => not_applicable === true);
                    }
                    
                    if (!_category3_score[_category3.category1_question_name]) {
                        const _category3_category1_score = this.scoring?.category1_scoring_pd.find(({category1_question_name}) => category1_question_name === _category3.category1_question_name);
                        // let { category1_question_code, category1_question_name, category1_question_name_ca, category1_question_name_ea, not_applicable_num, 환산_점수 } = _category3
                        let {
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ca,
                            category1_question_name_ea
                        } = _category3;
                        환산_점수 = _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0);
                        
                        _category3_score[_category3.category1_question_name] = {
                            category1_question_code,
                            category1_question_name_ko: category1_question_name,
                            category1_question_name: this.report_lang === 'ko' ? category1_question_name : this.report_lang === 'ca' ? category1_question_name_ca : category1_question_name_ea,
                            category1_score: this.roundToOneDecimalPlace(_category3_category1_score['환산_점수']),
                            min: this.roundToOneDecimalPlace(_category3_category1_score['환산_점수']),
                            max: null,
                            category3: []
                        };
                    }
                    
                    let {
                        category3_question_code,
                        category3_question_name,
                        category3_question_name_ca,
                        category3_question_name_ea,
                        환산_점수
                    } = _category3;
                    
                    if (!_is_category3_na) {
                        환산_점수 = this.roundToOneDecimalPlace(환산_점수);
                        if (환산_점수 > 0) {
                            _category3_score[_category3.category1_question_name]['max'] = Math.max(_category3_score[_category3.category1_question_name]['max'], 환산_점수);
                        }
                        // _category3_score[_category3.category1_question_name]["max"] = Math.max(_category3_score[_category3.category1_question_name]["max"], 환산_점수)
                        _category3_score[_category3.category1_question_name]['min'] = Math.min(_category3_score[_category3.category1_question_name]['min'], 환산_점수);
                    }
                    
                    _category3_score[_category3.category1_question_name].category3.push({
                        category3_question_code,
                        category3_question_name_kr: category3_question_name,
                        category3_question_name: this.report_lang === 'ko' ? category3_question_name : this.report_lang === 'ca' ? category3_question_name_ca : category3_question_name_ea,
                        score: _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0),
                        not_applicable: _is_category3_na
                    });
                    return _category3_score;
                }, {});
                
                const parseKey = str => str.split('.')[0] * 10000 + str.split('.')[1] * 100 + str.split('.')[2];
                
                Object.values(_category3_score).forEach((_category3_group) => {
                    _category3_group.min = _category3_group.max === _category3_group.min ? null : _category3_group.min;
                    _category3_group.category3.forEach(category3_ele => {
                        category3_ele.max = category3_ele.score === _category3_group.max;
                        category3_ele.min = category3_ele.score === _category3_group.min;
                        category3_ele.below = category3_ele.score < this.category2_score_standard;
                    });
                    _category3_group.category3 = _category3_group.category3.sort((a, b) => parseKey(a.category3_question_name) - parseKey(b.category3_question_name));
                    
                    _category3_group.min = _category3_group.min === null ? ' - ' : _category3_group.min;
                });
            }
            
            const _category3 = this.orderCategory1(Object.values(_category3_score), 'category1_question_name_ko');
            return {
                total: _total_score, category1: _category1_score, category2: _category2_score, category3: _category3
            };
        },
        evaluation_score_description() {
            return {
                'ko': `${this.companyInfo['회사명']}의 ${this.cover_title.join(' ')} 충족률은 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} % 입니다.`,
                'en': `The overall compliance of the ${this.cover_title.join(' ')} for ${this.companyInfo['회사명']} is ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} %.`,
                'ca': `${this.companyInfo['회사명']}在 ${this.cover_title}满意率 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} %。`
            };
        },
        companyInfo() {
            
            if (!this.reportData?.parser.values.length) {
                return {
                    '소재국가': ' - ',
                    '매출액': ' - ',
                    '근로자수': ' - ',
                    '근로자_정규직': ' - ',
                    '근로자_계약직': ' - ',
                    '근로자_일용직': ' - ',
                    '근로자_사내도급': ' - '
                };
            } else {
                const _company_info_field = ['소재국가', '매출액', '근로자수', '근로자_정규직', '근로자_계약직', '근로자_일용직', '근로자_사내도급'];
                const _company_info = [...this.reportData?.parser.values].reduce((_info, _value) => {
                    if (_company_info_field.includes(_value.criteria_name)) {
                        _info[_value.criteria_name] = !_value.value.length ? '(없음)' : _value.value[0];
                    } else {
                        _info[_value.criteria_name] = ' - ';
                    }
                    
                    return _info;
                }, {});
                
                const _company_info_exist_keys = Object.keys(_company_info);
                _company_info_field.forEach(_field => {
                    if (!_company_info_exist_keys.includes(_field)) {
                        _company_info[_field] = ' - ';
                    }
                });
                
                _company_info['회사명'] = this.reportData.info.company.company_name;
                _company_info['사업장 유형'] = this.reportData.info.company.hd_corporate;
                
                return _company_info;
            }
        },
        assessmentInfo() {
            let {
                service_type, requested_ts, in_progress_ts, in_assessment_ts, duedate_ts, completed_ts
            } = this.reportData.info;
            service_type = service_type === '일반' ? this.$t('일반 평가', this.report_lang) : this.$t('심화 평가', this.report_lang);
            
            let _assessmentInfo = {
                service_type: null, requested_date: requested_ts, duedate_date: duedate_ts, completed_date: completed_ts
            };
            
            if (service_type) _assessmentInfo.service_type = this.$t(service_type, this.report_lang);
            
            // 평가기간 실 평가기간으로 교체
            if (this.set_actual_duration) {
                _assessmentInfo.requested_date = this.report_lang === 'ko' ? dayjs(in_progress_ts).format('YYYY년 MM월 DD일') : dayjs(in_progress_ts).format('MM/DD/YYYY');
                
                _assessmentInfo.duedate_date = this.report_lang === 'ko' ? dayjs(in_assessment_ts).format('YYYY년 MM월 DD일') : dayjs(in_assessment_ts).format('MM/DD/YYYY');
            } else {
                if (_assessmentInfo.requested_date) {
                    _assessmentInfo.requested_date = this.report_lang === 'ko' ? dayjs(_assessmentInfo.requested_date).format('YYYY년 MM월 DD일') : dayjs(_assessmentInfo.requested_date).format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.requested_date = ' - ';
                }
                
                if (_assessmentInfo.duedate_date) {
                    _assessmentInfo.duedate_date = this.report_lang === 'ko' ? dayjs(_assessmentInfo.duedate_date).format('YYYY년 MM월 DD일') : dayjs(_assessmentInfo.duedate_date).format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.duedate_date = ' - ';
                }
                
                if (_assessmentInfo.completed_date) {
                    _assessmentInfo.completed_date = this.report_lang === 'ko' ? dayjs(_assessmentInfo.completed_date).format('YYYY년 MM월 DD일') : dayjs(_assessmentInfo.completed_date).format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.completed_date = dayjs().format(this.report_lang === 'ko' ? 'YYYY년 MM월 DD일' : 'MM/DD/YYYY');
                }
            }
            
            return _assessmentInfo;
        },
        ordered_cataory1() {
            return ['1. 인권 및 노동', '2. 윤리', '3. 환경', '4. 안전'];
        },
        category1_composition() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                return [{label: '인권', value: 0}, {label: '윤리', value: 0}, {label: '환경', value: 0}, {
                    label: '안전',
                    value: 0
                },];
            } else {
                const _category1_composition = this.scoring.scoring_pd.reduce((_cat1_composition, _score) => {
                    const {
                        satisfied,
                        category1_question_code,
                        category1_question_name,
                        category1_question_name_ca,
                        category1_question_name_ea
                    } = _score;
                    if (!_cat1_composition[category1_question_code]) {
                        _cat1_composition[category1_question_code] = {
                            category1_question_name, category1_question_name_ca, category1_question_name_ea, count: 0
                        };
                    }
                    
                    if (satisfied) {
                        ++_cat1_composition[category1_question_code]['count'];
                    }
                    
                    return _cat1_composition;
                }, {});
                
                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = Object.values(_category1_composition).find(({category1_question_name}) => category1_question_name === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            }
        },
        sub_imporatance_composition_description() {
            const total_subs = Object.values(this.category1_composition).reduce((_total_subs, _sub_count) => (_total_subs += _sub_count.count), 0);
            const cat1_count = this.scoring.category1_scoring_pd.map((item)=> item['문항 수']);
            const total_count = cat1_count.reduce((total, count) => total + count, 0);

            let _composition_description = null;
            if (this.report_lang === 'ko') {
                _composition_description = '2025년 현대차 사업장 ESG 평가는 각 법인의 인권 및 윤리 리스크 관리체계를 진단하고 개선 방향을 도출하기 위해 시행되었습니다. ';
                _composition_description += '평가 지표는 \'정책 수립\', \'실행 활동\', \'성과 관리\'의 이행 여부를 핵심 지표로 설계되었습니다.';
                _composition_description += `\n${this.headerInfo.company_name}의 평가는 인권 및 노동 분야 ${cat1_count[0]}개 지표, 윤리 분야 ${cat1_count[1]}개 지표 등 총 ${total_count}개 평가지표를 적용하여 실시되었으며, `;
                _composition_description += '각 지표별 응답 결과를 토대로 전체 지표 대비 획득 점수의 충족률을 산출하였습니다.';
            } else {
                _composition_description = 'The 2025 Hyundai Motor Business Site ESG Assessment aimed to evaluate each subsidiary\'s human rights and ethics risk management systems and identify potential areas for enhancement. ';
                _composition_description += 'The assessment focused on three dimensions: Policy Ownership, Implementation of Activities, and Performance of Activities.';
                _composition_description += `\nA total of ${total_count} indicators were utilized in the assessment for ${this.headerInfo.company_name}, including ${cat1_count[0]} indicators for human rights and labor, as well as ${cat1_count[1]} indicators addressing ethics. `;
                _composition_description += 'The compliance rate was calculated based on the responses to each indicator, representing the percentage of points achieved relative to the total possible points.';
            }
            return _composition_description;
        },
        section_score_description() {
            const top2category2_question_names = JSON.parse(JSON.stringify(this.scoringInfo?.category2));
            top2category2_question_names.sort((a, b) => {
                return b['환산_점수'] - a['환산_점수'];
            });
            const lowest2category2_question_names = JSON.parse(JSON.stringify(this.scoringInfo?.category2));
            lowest2category2_question_names.sort((a, b) => {
                return a['환산_점수'] - b['환산_점수'];
            });
            
            
            const total_count = this.scoring.category1_scoring_pd.reduce((total, item) => {
                total += item['문항 수'];
                return total;
            }, 0);
            
            const category3_count = this.scoring.category3_scoring_pd.length;
            
            let belowCnt = 0;
            let upCnt = 0;
            let naCnt = 0;
            
            this.scoring.category3_scoring_pd.forEach((category3) => {
                const score = category3['환산_점수'];
                const avg = this.benchMarkScore.category3[category3.category3_question_name].avg;
                if(score === 0 && category3['배점'] === 0){
                    naCnt++;
                }
                else if(score >= avg){
                    upCnt++;
                }
                else {
                    belowCnt++;
                }
            });
        
            

            let _section_score_description = '';
            if (this.report_lang === 'ko') {
                if(belowCnt > 0){
                    _section_score_description += `${this.reportData?.info?.company?.company_name}은/는 총 8개 대분류의 ${category3_count}개 주제, ${total_count}개 문항에 대해 사업장의 운영 체계 및 관리 실태 전반을 진단받았습니다. `;
                    _section_score_description += `그 중 ${upCnt}개 주제에서는 전체 사업장 평균 대비 우수한 수준을 보였지만, ${belowCnt}개 주제에서는 평균에 미치지 못해 개선이 필요한 것으로 나타났습니다.`;
                }
                else {
                    _section_score_description += `${this.reportData?.info?.company?.company_name}은/는 총 8개 대분류의 ${category3_count}개 주제, ${total_count}개 문항에 대해 사업장의 운영 체계 및 관리 실태 전반을 진단받았고, `;
                    _section_score_description += `그 중 ${upCnt}개 주제에서는 전체 사업장 평균 대비 우수한 수준을 보였습니다.`;
                }
                if(naCnt >0){
                    _section_score_description += ` (${naCnt}개 주제는 해당없음 처리됨)`;
                }
            } 
            else {
                if(belowCnt > 0){
                    let below_topic_name = belowCnt > 1 ? 'topics' : 'topic';
                    
                    _section_score_description += `${this.reportData?.info?.company?.company_name} underwent a comprehensive assessment of its operational systems and management practices across ${category3_count} topics within 8 major categories, covering ${total_count} indicators. `;
                    _section_score_description += `Among these, ${upCnt} topics showed performance above the overall site average. However, ${belowCnt} ${below_topic_name} fell below the average, indicating the need for improvement.`;
                }
                else {
                    _section_score_description += `${this.reportData?.info?.company?.company_name} underwent a comprehensive assessment of its operational systems and management practices across ${category3_count} topics within 8 major categories, covering ${total_count} indicators. `;
                    _section_score_description += `Among these, ${upCnt} topics showed performance above the overall site average.`;
                }
                if(naCnt === 1){
                    _section_score_description += ` (${naCnt} topic was marked as not applicable)`;
                }
                if(naCnt > 1){
                    _section_score_description += ` (${naCnt} topics were marked as not applicable)`;
                }
            }
            
            return _section_score_description;
        }
    },
    methods: {
        async createSummaryPage(doc, position_y) {
            position_y = this.firstElementSpacing;
            position_y = this.addTitle(doc, position_y, 1, '사업장 및 평가 정보');
            
            /**
             * 기업 기본정보: 사업장명, 소재국가, 매출액, 사업장 유형, 근로자수 (막대 차트)
             */
            
            let _column_width = this.pageContentWidth / 4;
            let [_assessment_info_table_styles_th, _assessment_info_table_styles_td] = [{
                ...this.tableStyles.th,
                cellWidth: _column_width
            }, {...this.tableStyles.td, cellWidth: _column_width}];
            
            
            let _assessment_info_table_body = [[{
                content: this.$t('평가기간', this.report_lang),
                styles: _assessment_info_table_styles_th
            }, {
                content: `${this.assessmentInfo.requested_date} ~ ${this.assessmentInfo.duedate_date}`,
                colSpan: 3,
                styles: _assessment_info_table_styles_td
            }]];
            
            if ((this.assessmentType && this.assessmentType === 'OSIS') || (!this.assessmentType && this.reportData.info.service_type === '심화')) {
                _assessment_info_table_body.push([{
                    content: this.$t('평가유형', this.report_lang),
                    styles: _assessment_info_table_styles_th
                }, {
                    content: this.$t('실사평가', this.report_lang), colSpan: 3, styles: _assessment_info_table_styles_td
                }]);
            }
            
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                styles: {...this.tableStyles.global},
                body: [[{
                    content: this.$t('사업장명', this.report_lang),
                    styles: _assessment_info_table_styles_th
                }, {
                    content: this.companyInfo['회사명'],
                    styles: _assessment_info_table_styles_td
                }, {
                    content: this.$t('사업장 코드', this.report_lang),
                    styles: _assessment_info_table_styles_th
                }, {
                    content: this.headerInfo.vendor_code,
                    styles: _assessment_info_table_styles_td
                }], [{
                    content: this.$t('소재국가', this.report_lang),
                    styles: _assessment_info_table_styles_th
                }, {
                    content: this.businessSiteCategory[this.headerInfo.vendor_code]?.[`country_${this.report_lang}`] ?? this.businessSiteCategory[this.headerInfo.vendor_code]?.['country_en'],
                    styles: _assessment_info_table_styles_td
                }, {content: this.$t('사업장 유형', this.report_lang), styles: _assessment_info_table_styles_th}, {
                    content: this.businessSiteCategory[this.headerInfo.vendor_code]?.[`business_type_${this.report_lang}`] ?? this.businessSiteCategory[this.headerInfo.vendor_code]?.['business_type_en'],
                    styles: _assessment_info_table_styles_td
                }], [{
                    content: this.$t('전체 근로자 수', this.report_lang),
                    styles: _assessment_info_table_styles_th
                }, {
                    content: this.companyInfo['근로자수'],
                    styles: _assessment_info_table_styles_td,
                    colSpan: 3
                },], ..._assessment_info_table_body],
                didDrawCell: (data) => this.jspdf_common_cell_font_convert(data)
            });
            
            
            this.setFont(doc, 'default', null, 'normal');
            doc.setTextColor(this.hyundai_colors.muted);
            const worker_guide_text = doc.splitTextToSize(`(*${this.$t('근로자 수 기준년도: {year}', this.report_lang, {year: 2024})})`, {fontSize: 7});
            const worker_guide_text_dim = doc.getTextDimensions(worker_guide_text, {fontSize: 7});
            
            const worker_guide_text_position_x = this.jsPDFOpt.margin.left + 64 + Number(worker_guide_text_dim.w);
            const worker_guide_text_position_y = doc.lastAutoTable.finalY - 22;
            
            doc.text(worker_guide_text, worker_guide_text_position_x, worker_guide_text_position_y);
            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            
            
            // 지표 구성 및 중요도 구성 진단
            const _section_subs_risk_composition_chartBox_padding = 5;
            const _subs_composition_box_position_x = this.jsPDFOpt.margin.left;
            const _subs_composition_padding = _section_subs_risk_composition_chartBox_padding * 3;
            const _subs_composition_area_width = this.pageContentWidth - _subs_composition_padding;
            
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(this.report_lang === 'ko' ? 11 : 9.5);
            doc.setLineHeightFactor(1.55);
            
            const _sub_composition_description = doc.splitTextToSize(this.sub_imporatance_composition_description, _subs_composition_area_width);
            const _sub_composition_text_dim = doc.getTextDimensions(_sub_composition_description, {fontSize: this.report_lang === 'ko' ? 12 : 10.2});
            
            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);
            const _subs_composition_box_height = _sub_composition_text_dim.h + _subs_composition_padding;
            const _subs_composition_box_width = this.pageContentWidth;
            doc.rect(this.jsPDFOpt.margin.left, position_y, _subs_composition_box_width, _subs_composition_box_height, 'FD');
            
            position_y += 11 - 1.55;
            const _subs_composition_area_position_x = _subs_composition_box_position_x + ((_subs_composition_box_width - _sub_composition_text_dim.w) / 2) + _subs_composition_padding;
            const _subs_composition_area_position_y = position_y + ((_subs_composition_box_height - _sub_composition_text_dim.h) / 2);
            doc.text(_sub_composition_description, _subs_composition_area_position_x, _subs_composition_area_position_y);
            doc.setLineHeightFactor(1.15);
            
            position_y += _sub_composition_text_dim.h + this.jsPDFOpt.spacing.section_sm;
            
            
            position_y = this.addTitle(doc, position_y, 2, this.$t('평가결과', this.report_lang));
            
            
            // 평가 충족률
            position_y = this.addTitle(doc, position_y, 3, this.$t('평가 충족률', this.report_lang), {
                skip_divider: true, no_padding: true
            });
            if (this.report_lang === 'en') {
                // doc.setFontSize(13.5)
                doc.setFontSize(12);
            } else {
                // doc.setFontSize(15)
                doc.setFontSize(13);
            }
            
            const _total_score_guide_box_padding = 10;
            const _total_score_guide_box_width = this.pageContentWidth;
            const _total_score_guide_area_width = _total_score_guide_box_width - (_total_score_guide_box_padding * 2);
            let _total_score_guide_text = doc.splitTextToSize(this.evaluation_score_description[this.report_lang], _total_score_guide_area_width);
            
            const _total_score_guide_dim = doc.getTextDimensions(_total_score_guide_text);
            const _total_score_guide_box_height = _total_score_guide_dim.h + (_total_score_guide_box_padding * 2);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, _total_score_guide_box_width, _total_score_guide_box_height, 'F');
            
            const _total_score_guide_text_position_x = this.jsPDFOpt.margin.left + _total_score_guide_box_padding;
            const _total_score_guide_text_position_y = position_y + ((_total_score_guide_box_height - _total_score_guide_dim.h) / 2) + (_total_score_guide_box_padding / 2);
            doc.text(_total_score_guide_text, _total_score_guide_text_position_x, _total_score_guide_text_position_y, {baseline: 'middle'});
            
            
            position_y += _total_score_guide_box_height + this.jsPDFOpt.spacing.title_xs;
            
            
            if (this.report_lang === 'en') {
                doc.setFontSize(12);
            } else {
                doc.setFontSize(13);
            }
            
            
            // 스코어박스 섹션
            const scorebox_height = this.report_lang === 'ko' ? 70 : 55;
            doc.setLineWidth(0);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, scorebox_height, 'D');
            position_y += scorebox_height;
            
            // 스코어박스 - 스코어 라벨(Total Score)
            if (this.report_lang === 'ca') {
                doc.setFont(this.jsPDFOpt.fontFamily_ca, 'normal');
            } else {
                doc.setFont(this.jsPDFOpt.fontFamily, 'normal');
            }
            
            doc.setFontSize(12);
            const _score_title_position_x = this.jsPDFOpt.margin.left + 10;
            const _score_title_position_y = (position_y - scorebox_height + 0.75) + this.jsPDFOpt.margin.top * 0.9;
            doc.text(this.report_lang === 'ca' ? '总分' : 'Total Compliance Rate', _score_title_position_x, _score_title_position_y);
            
            
            // 스코어박스 - 스코어(점수)
            const total_score_width = this.pageContentWidth * 0.4;
            this.setFont(doc, 'cover_company_name');
            doc.setFontSize(30);
            
            const _score = this.scoringInfo.total['환산_점수'];
            const _score_text = `${_score}%`;
            const _score_score = doc.splitTextToSize(_score_text, total_score_width);
            const _score_score_dim = doc.getTextDimensions(_score_score);
            const _score_position_x = _score_title_position_x + (((total_score_width - _score_title_position_x) - _score_score_dim.w) / 2);
            doc.text(_score_score, _score_position_x, position_y - (scorebox_height / 2) + (_score_score_dim.h / 2), {halign: 'center'});
            
            
            // 스코어박스 - 스코어바
            const scorebar_width = this.pageContentWidth * 0.6;
            const scorebar_height = 12;
            const scorebar_radius = 6;
            const scorebar_position_x = this.pageContentWidth * 0.425;
            const scorebar_position_y = position_y - (scorebox_height / 2) - (scorebar_height / 2);
            
            doc.setLineWidth(0);
            doc.setFillColor(228, 220, 211);
            doc.setDrawColor('#d6cdc4');
            doc.roundedRect(scorebar_position_x, scorebar_position_y, scorebar_width, scorebar_height, scorebar_radius, scorebar_radius, 'FD');
            
            // Draw the marker triangle
            const markerX = scorebar_position_x + ((_score / 100) * scorebar_width);
            doc.setFillColor(0, 0, 0);
            doc.triangle(markerX - 3, scorebar_position_y - 8, markerX + 3, scorebar_position_y - 8, markerX, scorebar_position_y - 3, 'F');
            
            // Draw the progress bar
            doc.setFillColor(...this.hyundai_colors_rgb.blue);
            doc.roundedRect(scorebar_position_x, scorebar_position_y, (_score / 100) * scorebar_width, scorebar_height, 5, 5, 'F');
            
            // Draw the Step Number
            doc.setFontSize(10);
            doc.setTextColor(this.hyundai_colors.blue);
            doc.text('0%', scorebar_position_x, scorebar_position_y + scorebar_height + 11);
            const _score_100_width = doc.getStringUnitWidth('100') * doc.getFontSize();
            doc.text('100%', scorebar_position_x + scorebar_width - _score_100_width / 2, scorebar_position_y + scorebar_height + 11);
            
            doc.setFontSize(9);
            doc.setTextColor('#999999');
            for (let i = 10; i < 100; i += 10) {
                doc.text(`${i}`, scorebar_position_x + (i / 100) * scorebar_width, scorebar_position_y + scorebar_height + 11, null, null, 'center');
            }
            position_y += this.jsPDFOpt.spacing.section_xs;
            
            // ESG 평가 영역별 결과
            position_y = this.addTitle(doc, position_y, 3, this.$t('평가 영역별 결과', this.report_lang));
            
            // ESG 평가 영역별 테이블
            let _category1_score_table_name_head = this.scoringInfo.category1.reduce((_added_category1_name, _category1) => {
                _added_category1_name.push({
                    content: _category1.question_name, styles: {...this.tableStyles.th, fontSize: 10}
                });
                return _added_category1_name;
            }, []);
            
            let _category1_score_table_rows = [[{
                content: this.$t('영역별 충족률', this.report_lang),
                colSpan: 2,
                styles: {...this.tableStyles.th, fontSize: 12},
                minCellHeight: 25
            }], [..._category1_score_table_name_head]];
            
            const _total_score_cell_width = 0;
            const _category1_score_cell_width = (this.pageContentWidth - _total_score_cell_width) / 2;
            const _category1_score_cell_height = this.pageContentHeight - position_y - this.jsPDFOpt.footerHeight;
            const _category1_score_chart_height = _category1_score_cell_height * 0.75;
            const _category1_score_chart_width = _category1_score_chart_height;
            let _category1_score_font_size = Math.min(19, 12 * (_category1_score_chart_height / 53));
            _category1_score_font_size = Math.max(13, _category1_score_font_size);
            
            let _category1_score_index = 0;
            let _category1_score_table_body = [];
            for (const _category1 of this.scoringInfo.category1) {
                if (this.category1PieChartInstance) {
                    this.category1PieChartInstance.destroy();
                    this.category1PieChartInstance = null;
                }
                
                
                _category1_score_table_body.push({
                    content: this.roundToOneDecimalPlace(_category1['환산_점수']) + '%',
                    category1_cell: true,
                    category1_score: this.roundToOneDecimalPlace(_category1['환산_점수']),
                    category1_img_url: await this.generateCategory1PieChartInstance(`rgba(${this.category1_composition_colors[_category1_score_index].join(',')})`, [this.roundToOneDecimalPlace(_category1['환산_점수']), 100 - this.roundToOneDecimalPlace(_category1['환산_점수'])]),
                    category1_question_name: _category1.question_name,
                    styles: {
                        ...this.tableStyles.td,
                        minCellHeight: _category1_score_cell_height,
                        cellWidth: _category1_score_cell_width,
                        valign: 'middle',
                        cellPadding: {top: 3.5},
                        fontSize: _category1_score_font_size
                    }
                });
                ++_category1_score_index;
            }
            
            _category1_score_table_rows.push(_category1_score_table_body);
            
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: {...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left},
                styles: {...this.tableStyles.global, halign: 'center'},
                body: _category1_score_table_rows,
                didDrawCell: async (data) => {
                    if (data.cell.raw?.category1_cell && data.cell.raw?.category1_cell === true) {
                        const _category1_score_chart_positon_x = data.cell.x + ((_category1_score_cell_width - _category1_score_chart_width) / 2);
                        const _category1_score_chart_positon_y = data.cell.y + ((_category1_score_cell_height - _category1_score_chart_height) / 2); // + 0.5
                        
                        doc.addImage(data.cell.raw.category1_img_url, 'png', _category1_score_chart_positon_x, _category1_score_chart_positon_y, _category1_score_chart_width, _category1_score_chart_height);
                        if (this.category1PieChartInstance) {
                            this.category1PieChartInstance.destroy();
                            this.category1PieChartInstance = null;
                        }
                    }
                }
            });
            
            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            
            return position_y;
        },
        generatecategory1AreaChartInstance(_data = this.scoringInfo.category1, opt = {}) {
            return new Promise((resolve) => {
                if (!_data) {
                    _data = this.scoringInfo.category1;
                }
                
                let _category1_data = _data.map(({환산_점수}) => 환산_점수);
                let _category1_label = _data.map(({question_name}) => this.$t(question_name, this.report_lang));
                if (this.report_lang === 'en') {
                    _category1_label = this.splitByManagement(_category1_label);
                }
                
                
                if (!opt.emphasis || typeof opt.emphasis === 'undefined') {
                    opt.emphasis = false;
                }
                
                let emphasis_max_label = null;
                if (!opt.emphasis_max || typeof opt.emphasis_max === 'undefined') {
                    opt.emphasis_max = false;
                } else {
                    let _max_score = Math.max(..._category1_data);
                    emphasis_max_label = _data.find(({환산_점수}) => 환산_점수 === _max_score);
                    emphasis_max_label = this.splitByManagement(this.$t(emphasis_max_label.question_name, this.report_lang));
                }
                
                let emphasis_min_label = null;
                if (!opt.emphasis_min || typeof opt.emphasis_min === 'undefined') {
                    opt.emphasis_min = false;
                } else {
                    let _min_score = Math.min(..._category1_data);
                    emphasis_min_label = _data.find(({환산_점수}) => 환산_점수 === _min_score);
                    emphasis_min_label = this.splitByManagement(this.$t(emphasis_min_label.question_name, this.report_lang));
                }
                
                const _scope1_data = {
                    labels: _category1_label, datasets: [{
                        data: _category1_data,
                        fill: true,
                        backgroundColor: 'rgba(194, 24, 91, 0.4)',
                        borderColor: 'rgb(194, 24, 91)',
                        pointBorderColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(194, 24, 91, 1)';
                                }
                            }
                            
                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 53, 1)';
                                }
                            }
                            
                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(194, 24, 91, 1)';
                                }
                            }
                            
                            return 'rgb(206, 66, 122)';
                        },
                        pointBackgroundColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(194, 24, 91, 0.6)';
                                }
                            }
                            
                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 5, 0.6)';
                                }
                            }
                            
                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(194, 24, 91, 0.6)';
                                }
                            }
                            
                            return 'rgba(181, 69, 114, 0.5)';
                        }
                    }]
                };
                
                const _common_option = {
                    global: {
                        aspectRatio: this.report_lang === 'en' ? null : 4.7 / 3,
                        responsive: false,
                        maintainAspectRatio: false,
                        devicePixelRatio: 1.5,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0, onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    }, plugins: {
                        legend: {display: false}, datalabels: {
                            display: false
                        },
                    }, scales: {
                        max: 100, beginAtZero: true, ticks: {
                            display: false
                        }
                    }, layout: {}
                };
                
                let _font_size = {
                    default: this.report_lang === 'en' ? 12.5 : 14.5,
                    enphasis: this.report_lang === 'en' ? 13.5 : this.report_lang === 'ca' ? 15.5 : 16
                };
                
                const _scope1_area_option = {
                    ..._common_option.global,
                    layout: _common_option.layout,
                    elements: {line: {borderWidth: 1.5}},
                    scales: {
                        r: {
                            ..._common_option.scales, ticks: {
                                ..._common_option.scales.ticks, stepSize: 25, color: '#E0E0E0', autoSkip: false, // 레이블 건너뛰기 해제
                                overflow: 'hidden' // 레이블이 차트 영역 밖으로 넘치지 않도록 설정
                            }, grid: {
                                color: '#E0E0E0'
                            }, pointLabels: {
                                display: true, padding: 7, font: {
                                    size: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return _font_size.enphasis;
                                            }
                                        }
                                        
                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return _font_size.enphasis;
                                            }
                                        }
                                        
                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return _font_size.enphasis;
                                            }
                                        }
                                        
                                        return _font_size.default;
                                    }, weight: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return 700;
                                            }
                                        }
                                        
                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return 700;
                                            }
                                        }
                                        
                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return 700;
                                            }
                                        }
                                        
                                        return 500;
                                    },
                                }, color: (context) => {
                                    if (opt.emphasis_max) {
                                        if (context.label === emphasis_max_label) {
                                            return 'rgba(194, 24, 91, 1)';
                                        }
                                    }
                                    
                                    if (opt.emphasis_min) {
                                        if (context.label === emphasis_min_label) {
                                            return 'rgba(229, 57, 5, 1)';
                                        }
                                    }
                                    
                                    if (opt.emphasis) {
                                        if (context.label === opt.emphasis_label) {
                                            return 'rgba(194, 24, 91, 1)';
                                        }
                                    }
                                    
                                    return '#616161';
                                }
                            }
                        }
                    },
                    plugins: _common_option.plugins
                };
                
                if (!this.category1AreaChartInstance) {
                    this.category1AreaChartInstance = this.$chartjs.createChart(document.getElementById('category1-chart-area'), {
                        type: 'radar', data: _scope1_data, options: _scope1_area_option
                    });
                } else {
                    this.$chartjs.updateChart(this.category1AreaChartInstance, _scope1_data, _scope1_area_option);
                }
                
            });
        },
        generateCategory2ContraryAreaChartInstance(doc, _data = this.scoringInfo.category2) {
            return new Promise((resolve) => {
                if (!_data) {
                    _data = this.scoringInfo.category2;
                }
                
                const naIdx = [];
                const _current_data = this.scoringInfo.category2.map(({환산_점수, 배점}, idx) => {
                    if(환산_점수 === 0 && 배점 === 0){
                        naIdx.push(idx);
                    }
                    return 환산_점수;
                });
                
                const mapCategoryValid = {};
                const labels = this.scoringInfo.category2.map(({question_name}) => {
                    const category = question_name.split('. ')[0];
                    mapCategoryValid[category] = true;
                    return doc.splitTextToSize(question_name, 80);
                });
                const avgBenchmark = [];
                const tierAvgBenchmark = [];
                Object.entries(this.benchMarkScore.category2).forEach(([key, value]) => {
                    const category = key.split('. ')[0];
                    if(mapCategoryValid[category]){
                        avgBenchmark.push(value.avg);
                        tierAvgBenchmark.push(value.tier_avg[this.project_code]);
                    }
                    
                });
                
                const _scope2_data = {
                    labels,
                    datasets: [
                        {
                            label: this.headerInfo.company_name,
                            data: _current_data,
                            borderColor: 'rgba(0, 44, 95, 0.6)',
                            backgroundColor: 'rgba(0, 44, 95, 0.1)',
                            pointBackgroundColor: 'rgba(0, 44, 95, 1)',
                            pointBorderColor: 'rgba(0, 44, 95, 0.6)',
                            pointRadius: 3,
                            borderWidth: 2,
                            tension: 0
                        },
                        {
                            label: this.$t('전체 평균', this.report_lang),
                            data: avgBenchmark,
                            borderColor: this.hyundai_colors.gold,
                            backgroundColor: 'transparent',
                            borderDash: [4, 4],
                            pointBackgroundColor: this.hyundai_colors.gold,
                            pointBorderColor: this.hyundai_colors.gold,
                            pointRadius: 2,
                            borderWidth: 1,
                            tension: 0
                        },
                        {
                            label: this.$t('Tier 평균', this.report_lang),
                            data: tierAvgBenchmark,
                            borderColor: this.hyundai_colors.muted,
                            backgroundColor: 'transparent',
                            borderDash: [4, 4],
                            pointBackgroundColor: this.hyundai_colors.muted,
                            pointBorderColor: this.hyundai_colors.muted,
                            pointRadius: 2,
                            borderWidth: 1,
                            tension: 0
                        }]
                };
                
                
                const _common_option = {
                    global: {
                        // aspectRatio: this.report_lang === 'en' ? null : 4.7/3,
                        responsive: false,
                        maintainAspectRatio: false,
                        devicePixelRatio: 1.5,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0, onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    }
                };
                
                const _scope2_area_option = {
                    ..._common_option.global,
                    layout: {
                        padding: {
                            top: 180,
                            bottom: 180,
                            left: 0,
                            right: 0
                        }
                    },
                    plugins: {
                        legend: {display: false},
                        datalabels: {display: false},
                    },
                    scales: {
                        r: {
                            min: 0, max: 100,
                            ticks: {
                                display: false,
                            },
                            grid: false,
                            pointLabels: {
                                display: false,
                            }
                        }
                    }
                };
                
                const pointLabelOffsets = [
                    {x: 0, y: this.report_lang === 'en' ? -30 : -20},   // 1번 라벨: 왼쪽(예시)
                    {x: 60, y: 0},   // 2번 라벨: 위쪽(예시)
                    {x: 60, y: 0},   // 3번 라벨: 위쪽(예시)
                    {x: 0, y: this.report_lang === 'en' ? 10 : 20},   // 4번 라벨: 위쪽(예시)
                    {x: -70, y: 0},   // 5번 라벨: 위쪽(예시)
                    {x: -70, y: 0},   // 6번 라벨: 위쪽(예시)
                ];
                
                if (!this.category2ContraryAreaChartInstance) {
                    this.category2ContraryAreaChartInstance = this.$chartjs.createChart(document.getElementById('category2-contrary-chart-area'), {
                        type: 'radar', data: _scope2_data, options: _scope2_area_option,
                        plugins: [{
                            id: 'customPointLabels',
                            afterDraw(chart) {
                                const {ctx, scales} = chart;
                                const rScale = scales.r;
                                
                                const labels = rScale._pointLabels;
                                const data = chart.data.datasets[0].data;
                                const centerX = rScale.xCenter;
                                const centerY = rScale.yCenter;
                                const radius = rScale.drawingArea + 24; // 라벨을 본체에서 떨어뜨릴 거리
                                
                                labels.forEach((label, i) => {
                                    const angle = rScale.getIndexAngle(i) - Math.PI / 2;
                                    let x = centerX + Math.cos(angle) * radius;
                                    let y = centerY + Math.sin(angle) * radius;
                                    
                                    // 오프셋 적용 (라벨별로 다르게)
                                    if (pointLabelOffsets[i]) {
                                        x += pointLabelOffsets[i].x;
                                        y += pointLabelOffsets[i].y;
                                    }
                                    
                                    ctx.save();
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'middle';
                                    // 라벨
                                    const resizedLabel = doc.splitTextToSize(label, 80);
                                    let labelY = y - 9;
                                    ctx.font = 'bold 15px sans-serif';
                                    ctx.fillStyle = '#666';
                                    resizedLabel.forEach(elem => {
                                        ctx.fillText(`${elem}`, x, labelY);
                                        
                                        labelY += 20;
                                    });
                                    
                                    // 값 (강조)
                                    ctx.font = 'bold 17px sans-serif';
                                    ctx.fillStyle = '#002c5f';
                                    let conv_data = '';
                                    if(naIdx.includes(i)){
                                        conv_data = 'N/A';
                                    }
                                    else {
                                        conv_data = `${data[i]}%`;
                                    }
                                    ctx.fillText(conv_data, x, labelY);
                                    ctx.restore(); // 상태 복원
                                });
                            }
                        }]
                    });
                } else {
                    this.$chartjs.updateChart(this.category2ContraryAreaChartInstance, _scope2_data, _scope2_area_option);
                }
            });
        },
        
        generateCategory1PieChartInstance(keyColor, category1_score) {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: category1_score, fill: true, backgroundColor: [// 'rgba(96, 125, 139, 1)',
                            keyColor, 'rgba(236, 239, 241, 0.7)'], borderColor: [// 'rgba(96, 125, 139, 1)',
                            keyColor, 'rgba(144, 164, 174, 0.6)'],
                    }]
                };
                
                const _common_option = {
                    global: {
                        aspectRatio: 5 / 5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0, onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    }, plugins: {
                        datalabels: {display: false},
                    }
                };
                
                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: {line: {borderWidth: 1}},
                    scales: {},
                    plugins: _common_option.plugins,
                    cutout: '76%'
                };
                
                if (!this.category1PieChartInstance) {
                    this.category1PieChartInstance = this.$chartjs.createChart(document.getElementById('category1-chart-pie'), {
                        type: 'doughnut', data: _scope1_data, options: _scope1_area_option
                    });
                } else {
                    this.$chartjs.updateChart(this.category1PieChartInstance, _scope1_data, _scope1_area_option);
                }
            });
        }, drawCategory1PieChartImage() {
            return this.category1PieChartInstance.toBase64Image('image/jpg', 1);
        },
        async createCategory2ScorePage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc, 2);
            position_y = this.firstElementSpacing;
            
            
            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 관리 수준', this.report_lang));
            
            /**
             * guide text 생성
             */
            const _category1_section_score_desc_padding = 5;
            const _category1_section_score_desc_box_position_x = this.jsPDFOpt.margin.left;
            
            const _category1_section_score_desc_area_width = this.pageContentWidth - (_category1_section_score_desc_padding * 2);
            
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(11);
            doc.setLineHeightFactor(1.55);
            const _category1_score_description = doc.splitTextToSize(this.section_score_description, _category1_section_score_desc_area_width);
            const _category1_score_desc_dim = doc.getTextDimensions(_category1_score_description);
            
            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);
            const _category1_score_desc_box_height = _category1_score_desc_dim.h + (_category1_section_score_desc_padding * 3);
            const _category1_score_desc_box_width = this.pageContentWidth;
            doc.rect(_category1_section_score_desc_box_position_x, position_y, _category1_score_desc_box_width, _category1_score_desc_box_height, 'FD');
            
            position_y += 11 - 1.55;
            const _subs_composition_area_position_x = _category1_section_score_desc_box_position_x + _category1_section_score_desc_padding; // _category1_section_score_desc_box_position_x + ((_category1_score_desc_box_width - _category1_score_desc_dim.w) / 2) + _category1_section_score_desc_padding
            const _subs_composition_area_position_y = position_y + ((_category1_score_desc_box_height - _category1_score_desc_dim.h) / 3);
            doc.text(_category1_score_description, _subs_composition_area_position_x, _subs_composition_area_position_y);
            doc.setLineHeightFactor(1.15);
            
            position_y += _category1_score_desc_box_height;
            
            /**
             * radar 차트 생성
             */
            const _category2_area_chart = await this.generateCategory2ContraryAreaChartInstance(doc);
            const _category2_score_box_size = this.pageContentWidth;
            const _category2_score_box_height = _category2_score_box_size * 0.5;
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, _category2_score_box_size, _category2_score_box_height * 1.25, 'F');
            
            const _category2_score_chart_height = _category2_score_box_height * 1.6;
            const _category2_score_chart_position_x = this.jsPDFOpt.margin.left + _category2_score_box_size / 4 - 60;
            const _category2_score_chart_position_y = position_y + ((_category2_score_box_height - _category2_score_chart_height) / 2) + 20;
            doc.addImage(_category2_area_chart, 'png', _category2_score_chart_position_x, _category2_score_chart_position_y, _category2_score_chart_height, _category2_score_chart_height);
            
            // 차트 범례 생성
            let startX = this.jsPDFOpt.margin.left + 10;
            let startY = position_y + 10;
            let lineLen = 16;
            let circleR = 2.5;
            let gapY = 9; // 각 항목 세로 간격
            
            const iter_data = [
                {label: this.headerInfo.company_name, color: this.hyundai_colors_rgb.blue},
                {label: this.$t('Tier 평균', this.report_lang), color: this.hyundai_colors_rgb.muted},
                {label: this.$t('전체 평균', this.report_lang), color: this.hyundai_colors_rgb.gold},
            ];
            for (let i = 0; i < 3; i++) {
                const {color, label} = iter_data[i];
                doc.setDrawColor(...color); // 파란색
                doc.setLineWidth(1.2);
                if (i !== 0) {
                    doc.setLineDashPattern([1, 2], 0); // 점선
                }
                doc.line(startX, startY, startX + lineLen, startY); // 실선
                if (i !== 0) {
                    doc.setLineDashPattern([], 0); // 점선 해제
                }
                doc.setFillColor(...color);
                doc.circle(startX + 8, startY, circleR, 'F'); // 원
                this.setFont(doc, 'table_th', null, 'bold');
                doc.setTextColor(...color);
                doc.text(label, startX + lineLen + 6, startY + 1.5);
                startY += gapY; // 다음 항목으로 이동
                
            }
            position_y += _category2_score_box_height + 60;
            
            /**
             * line chart 생성
             */
            const score_0 = doc.splitTextToSize('0%');
            const score_0_dim = doc.getTextDimensions(score_0, {fontSize: 9});
            const score_100 = doc.splitTextToSize('100%');
            const score_100_dim = doc.getTextDimensions(score_100, {fontSize: 9});
            
            
            const half_length = Math.ceil(this.scoringInfo.category2.length / 2);
            const iter = {
                to: [0, half_length],
                end: [half_length, this.scoringInfo.category2.length],
                x_position: [this.jsPDFOpt.margin.left + score_0_dim.w + 5, this.pageContentWidth * 0.65],
                x_position_end: [(this.pageContentWidth * 0.55 - score_100_dim.w - 5), (this.jsPDFOpt.margin.left + this.pageContentWidth - score_100_dim.w - 5)]
            };
            for (let i = 0; i < 2; i++) {
                for (let j = iter.to[i]; j < iter.end[i]; j++) {
                    const _category2 = this.scoringInfo.category2[j];
                    const _category2_idx = j % half_length;
                    const _category2_score_indicator_position_x = iter.x_position[i];
                    const _category2_score_indicator_position_x_end = iter.x_position_end[i];
                    
                    
                    const _category2_key = _category2.question_name_ko;
                    const {avg, tier_avg} = this.benchMarkScore.category2[_category2_key];
                    
                    const _score_category2_name = doc.splitTextToSize(_category2.question_name);
                    const _score_category2_name_dim = doc.getTextDimensions(_score_category2_name, {fontSize: 8.5});
                    
                    this.setFont(doc, null, null, 'medium');
                    doc.setFontSize(10);
                    
                    const _score_category2_position_x = _category2_score_indicator_position_x - score_0_dim.w - 5;
                    const _score_category2_position_y = position_y + _score_category2_name_dim.h + (_category2_score_box_height * ((_category2_idx) / this.scoringInfo.category2.length)) + (_category2_idx * 16);
                    doc.text(_score_category2_name, _score_category2_position_x, _score_category2_position_y);
                    
                    
                    const _score_category2_x_axis_position_x = _score_category2_position_x + score_0_dim.w + 3;
                    const _score_category2_x_axis_position_y = _score_category2_position_y + _score_category2_name_dim.h + 8;
                    doc.setLineDashPattern([3, 2], 1);
                    doc.setLineWidth(0.35);
                    doc.setDrawColor('#c8c8c8');
                    doc.line(_score_category2_x_axis_position_x, _score_category2_x_axis_position_y, _category2_score_indicator_position_x_end, _score_category2_x_axis_position_y);
                    doc.setLineDashPattern([], 0);
                    
                    this.setFont(doc, null, null, 'normal');
                    doc.setFontSize(9);
                    const _category2_score_0_position_y = _score_category2_x_axis_position_y + (score_0_dim.h / 2);
                    doc.text(score_0, _score_category2_position_x, _category2_score_0_position_y);
                    doc.text(score_100, _category2_score_indicator_position_x_end + score_100_dim.w - 7, _category2_score_0_position_y);
                    
                    
                    const _benchmark_score_avg_indicator_common_opt = {label_position: 'bottom', label_font_size: 7};
                    const _benchmark_score_avg_indicator_common_avg = {
                        ..._benchmark_score_avg_indicator_common_opt,
                        indicator_fill_color: [...this.hyundai_colors_rgb.gold, 0.7],
                        indicator_border_color: this.hyundai_colors_rgb.gold,
                        indicator_line_style: 'dashed_border_only',
                        fill_background: false
                    };
                    const _benchmark_score_avg_indicator_position_x = this.getXFromScore(_category2_score_indicator_position_x, _category2_score_indicator_position_x_end, avg);
                    this.drawScoreIndicator_hyundai(doc, _benchmark_score_avg_indicator_position_x, _score_category2_x_axis_position_y, avg, _benchmark_score_avg_indicator_common_avg);
                    
                    const _benchmark_score_tier_avg_indicator_common_avg = {
                        ..._benchmark_score_avg_indicator_common_opt,
                        indicator_fill_color: [...this.hyundai_colors_rgb.muted, 0.7],
                        indicator_border_color: this.hyundai_colors_rgb.muted,
                        indicator_line_style: 'dashed_border_only',
                        fill_background: false,
                        label_y_position: 5
                    };
                    const _benchmark_score_tier_avg_indicator_position_x = this.getXFromScore(_category2_score_indicator_position_x, _category2_score_indicator_position_x_end, tier_avg[this.project_code]);
                    this.drawScoreIndicator_hyundai(doc, _benchmark_score_tier_avg_indicator_position_x, _score_category2_x_axis_position_y, tier_avg[this.project_code], _benchmark_score_tier_avg_indicator_common_avg);
                    
                    const _score_indicator_position_x = this.getXFromScore(_category2_score_indicator_position_x, _category2_score_indicator_position_x_end, _category2['환산_점수']);
                    
                    let target_score = _category2['환산_점수'];
                    if(_category2['환산_점수'] === 0 && _category2['배점'] === 0){
                        target_score = 'N/A';
                    }
                    this.drawScoreIndicator_hyundai(doc, _score_indicator_position_x, _score_category2_x_axis_position_y, target_score, {
                        size: 3.5,
                        indicator_fill_color: this.hyundai_colors_rgb.blue,
                        indicator_border_color: [0, 50, 111],
                        label_font_size: 8
                    });
                }
            }
            
            position_y += _category2_score_box_height - this.jsPDFOpt.spacing.section_xs;
            
            const guide_text_position_y = position_y - 20;
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setTextColor(this.hyundai_colors.muted);
            const guide_text = doc.splitTextToSize(`* ${this.$t('\'1.1. 인권 및 노동 리스크\', \'2.2. 그린워싱 리스크 관리\' 주제는 전체 충족률에 반영되지 않는 주제로, 평가 분석 미제공', this.report_lang)}`, _category1_section_score_desc_area_width);
            doc.text(guide_text, _category1_section_score_desc_box_position_x, guide_text_position_y);
            position_y = guide_text_position_y + this.jsPDFOpt.spacing.section_xs;
            
            
            if (this.checkNeedNewPage(doc, position_y, 100)) {
                position_y = this.firstElementSpacing;
            }
            
            
            position_y = this.addTitle(doc, position_y, 2, this.$t('영역별 충족률 비교 분석', this.report_lang), {skip_divider: true});
            
            let _cat3_padding = 8;
            let _cat3_posistion_y = position_y;
            let _cat3_posistion_x_left = this.jsPDFOpt.margin.left;
            let _cat3_posistion_x_right = this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) + _cat3_padding;
            let _cat3_score_box_width = (this.pageContentWidth / 2) - _cat3_padding;
            let _cat3_score_box_height = 53;
            
            this.scoringInfo.category3.forEach(({category1_question_name, category3}) => {
                if (this.checkNeedNewPage(doc, _cat3_posistion_y, 60)) {
                    _cat3_posistion_y = this.firstElementSpacing;
                }
                // Category1 타이틀 추가
                _cat3_posistion_y = this.addTitle(doc, _cat3_posistion_y, 3, category1_question_name) + this.jsPDFOpt.spacing.title_xs;
                
                
                const _category3_chart_box_padding = 3;
                const _category3_chart_box_height = _cat3_score_box_height - (_category3_chart_box_padding * 2);
                const _category3_chart_box_width = _cat3_score_box_width - (_category3_chart_box_padding * 2);
                
                const _category3_label_area_width_spacing = this.report_lang === 'ko' ? 0 : 2;
                const max_text_width = Math.max(doc.getTextDimensions(doc.splitTextToSize(this.$t('전체 최고', this.report_lang)), {fontSize: 9.5}).w, doc.getTextDimensions(doc.splitTextToSize(this.$t('전체 평균', this.report_lang)), {fontSize: 9.5}).w,);
                const _category3_label_area_width = max_text_width + _category3_label_area_width_spacing;
                
                let _label_company_name = '';
                for (const category3LabelAreaWidthElement of this.headerInfo.company_name) {
                    if (doc.getTextDimensions(doc.splitTextToSize(_label_company_name + category3LabelAreaWidthElement), {fontSize: 9.5}).w > _category3_label_area_width) {
                        _label_company_name += '...';
                        break;
                    }
                    _label_company_name += category3LabelAreaWidthElement;
                }
                
                
                const _category3_chart_bar_area_width = _category3_chart_box_width - _category3_label_area_width - _category3_chart_box_padding;
                
                this.setFont(doc, null, null, 'medium');
                
                
                category3.forEach((_cat3, _cat3_idx) => {
                    let {category3_question_name, category3_question_name_kr, not_applicable, score} = _cat3;
                    const _category3_name = doc.splitTextToSize(category3_question_name);
                    const _category3_name_dim = doc.getTextDimensions(_category3_name, {fontSize: 10});
                    
                    let [avg, tier_avg,  bm_not_applicable] = [0, 0, 0, false];
                    if (this.benchMarkScore.category3[category3_question_name_kr]) {
                        const _benchmark_store = this.benchMarkScore.category3[category3_question_name_kr];
                        avg = _benchmark_store.avg;
                        tier_avg = _benchmark_store.tier_avg[this.project_code];
                    } else {
                        bm_not_applicable = true;
                    }
                    
                    const _category3_chart_labels = [
                        {
                            label: doc.splitTextToSize(this.$t('전체 평균', this.report_lang)),
                            value: avg,
                            is_na: bm_not_applicable,
                            fillColor: this.hyundai_colors_rgb.gold,
                            textColor: '#ffffff',
                            fontWeight: 'normal'
                        },
                        {
                            label: doc.splitTextToSize(this.$t('Tier 평균', this.report_lang)),
                            value: tier_avg,
                            is_na: tier_avg == null ? true : bm_not_applicable,
                            fillColor: this.hyundai_colors_rgb.muted,
                            textColor: '#ffffff',
                            fontWeight: 'normal'
                        },
                        
                        {
                            label: doc.splitTextToSize(this.$t('당 사업장', this.report_lang)),
                            value: score,
                            is_na: not_applicable,
                            fillColor: this.hyundai_colors_rgb.blue,
                            textColor: '#ffffff',
                            fontWeight: 'semibold'
                        }];
                    
                    if (this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height + _category3_name_dim.h)) {
                        _cat3_posistion_y = this.firstElementSpacing;
                    }
                    
                    let _cat3_score_position_x = _cat3_idx % 2 === 0 ? _cat3_posistion_x_left : _cat3_posistion_x_right;
                    this.setFont(doc, null, null, 'normal');
                    doc.setFontSize(this.report_lang === 'ko' ? 10 : 9.5);
                    
                    if (_cat3_idx % 2 === 0) {
                        _cat3_posistion_y += _category3_name_dim.h * 1.75;
                    }
                    
                    // Category3 타이틀 추가
                    doc.text(_category3_name, _cat3_score_position_x, _cat3_posistion_y);
                    
                    // Category3 차트 박스 그리기
                    doc.setLineWidth(0.5);
                    doc.setDrawColor(224, 224, 224);
                    const _category3_chart_box_position_y = _cat3_posistion_y + 3;
                    doc.rect(_cat3_score_position_x, _category3_chart_box_position_y, _cat3_score_box_width, _cat3_score_box_height, 'D');
                    
                    // Category3 차트 박스 내 영역 그리기
                    doc.setDrawColor(255, 255, 255);
                    const _category3_chart_area_position_x = _cat3_score_position_x + _category3_chart_box_padding;
                    const _category3_chart_area_position_y = _category3_chart_box_position_y + _category3_chart_box_padding;
                    doc.rect(_category3_chart_area_position_x, _category3_chart_area_position_y, _category3_chart_box_width, _category3_chart_box_height, 'D');
                    
                    // Category3 차트 박스 내 X축 그리기
                    const _category3_chart_y_axis_position_x = _category3_chart_area_position_x + _category3_label_area_width;
                    const _category3_chart_y_axis_position_y_end = _category3_chart_area_position_y + _category3_chart_box_height;
                    doc.setLineWidth(0.5);
                    doc.setDrawColor('#E0E0E0');
                    doc.line(_category3_chart_y_axis_position_x, _category3_chart_area_position_y, _category3_chart_y_axis_position_x, _category3_chart_y_axis_position_y_end);
                    
                    let _cat_label_position_y = _category3_chart_area_position_y;
                    _category3_chart_labels.forEach((_cat_label) => {
                        // Category3 차트 - 라벨 타이틀 추가
                        const _cat_label_dim = doc.getTextDimensions(_cat_label.label, {fontSize: 8});
                        const _cat_label_bar_position_x = _category3_chart_y_axis_position_x - _cat_label_dim.w - _category3_chart_box_padding;
                        this.setFont(doc, null, null, _cat_label.fontWeight);
                        doc.setFontSize(8);
                        _cat_label_position_y += _cat_label_dim.h + 6.5;
                        doc.text(_cat_label.label, _cat_label_bar_position_x, _cat_label_position_y);
                        
                        const _category3_chart_bar_height = 7;
                        const _category3_chart_bar_posistion_y = _cat_label_position_y - 5.5;
                        if (_cat_label.value || typeof _cat_label.is_na !== 'undefined') {
                            // Category3 차트 - 막대 차트 추가
                            const _category3_chart_bar_posistion_x_end = _cat_label.is_na === true ? 0 : _category3_chart_bar_area_width * (_cat_label.value / 100);
                            doc.setFillColor(..._cat_label.fillColor);
                            doc.rect(_category3_chart_y_axis_position_x, _category3_chart_bar_posistion_y, _category3_chart_bar_posistion_x_end, _category3_chart_bar_height, 'F');
                            const _category3_chart_bar_width = _cat_label.is_na ? 0 : _category3_chart_bar_posistion_x_end - _category3_chart_y_axis_position_x;
                            
                            let _category3_chart_datalabel = _cat_label.is_na ? 'N/A' : `${_cat_label.value}%`;
                            _category3_chart_datalabel = doc.splitTextToSize(_category3_chart_datalabel);
                            const _category3_chart_datalabel_dim = doc.getTextDimensions(_category3_chart_datalabel, {fontSize: 7});
                            const _category3_chart_datalabel_position_x = _cat_label.is_na || _cat_label.value === 0 ? 5 : _cat_label.value < 20 ? _category3_chart_y_axis_position_x + _category3_chart_bar_width + _category3_chart_datalabel_dim.w + 15 : _category3_chart_y_axis_position_x + _category3_chart_bar_width - _category3_chart_datalabel_dim.w;
                            
                            // Category3 차트 - 데이터라벨 추가
                            this.setFont(doc, null, null, _cat_label.fontWeight);
                            if (_cat_label.is_na || _category3_chart_datalabel == 0 || _cat_label.value < 20) {
                                doc.setTextColor('#424242');
                            } else {
                                doc.setTextColor(_cat_label.textColor);
                            }
                            
                            doc.setFontSize(7);
                            const _category3_chart_datalabel_position_y = _category3_chart_bar_posistion_y + _category3_chart_datalabel_dim.h + 0.2;
                            doc.text(_category3_chart_datalabel, _category3_chart_y_axis_position_x + (_category3_chart_datalabel_position_x / 2), _category3_chart_datalabel_position_y);
                        }
                    });
                    
                    if (!this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height) && (_cat3_idx % 2 === 1 || (category3.length - 1 === _cat3_idx))) {
                        _cat3_posistion_y += _category3_name_dim.h + _cat3_score_box_height + 4; // + this.jsPDFOpt.spacing.title_xs
                    } else if (this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height)) {
                        _cat3_posistion_y = this.firstElementSpacing;
                    }
                });
                
                _cat3_posistion_y += this.jsPDFOpt.spacing.section_xs;
            });
            
            position_y += _cat3_posistion_y + this.jsPDFOpt.spacing.section_md;
            return position_y;
        },
        generatePartialSummaryPage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc);
            position_y = this.firstElementSpacing;
            
            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 평가결과 요약', this.report_lang));
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(12);
            let _partial_score_guide_padding = 10;
            let _partial_score_guide_text = this.report_lang === 'ko' ? `${this.companyInfo['회사명']}의 영역별 충족률과 세부 항목별 충족률은 다음과 같습니다.` : this.report_lang === 'en' ? `The compliance rate by area and the detailed compliance rate for ${this.companyInfo['회사명']} are as follows.` : `${this.companyInfo['회사명']} 各地区各细项的满意率如下。`;
            _partial_score_guide_text = doc.splitTextToSize(_partial_score_guide_text, this.pageContentWidth - (_partial_score_guide_padding * 2));
            
            let _partial_score_guide_text_dim = doc.getTextDimensions(_partial_score_guide_text);
            let _partial_score_guide_card_height = _partial_score_guide_text_dim.h + (_partial_score_guide_padding * 2);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _partial_score_guide_card_height, 'F');
            
            let _partial_score_guide_text_position_y = position_y + (_partial_score_guide_card_height - _partial_score_guide_text_dim.h) - 1;
            doc.text(_partial_score_guide_text, this.jsPDFOpt.margin.left + _partial_score_guide_padding, _partial_score_guide_text_position_y);
            
            position_y += _partial_score_guide_card_height + this.jsPDFOpt.spacing.section_xs;
            
            // 테이블 범주
            const _fill_color = {below: '#F9D7D7', na: '#E0E0E0'};
            let legends_ko = ['기준미달 (50% 미만)', '해당없음, 평가제외'];
            let _category3_table_legend_ele = this.report_lang === 'en' ? (this.pageContentWidth / 2) : (this.pageContentWidth / 3);
            let _longest_legend_position_x = this.report_lang === 'en' ? this.jsPDFOpt.margin.left + 50 : this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) + 20;
            let _legend_mark_width = 20;
            
            Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                this.setFont(doc, 'table_td', null, 'normal');
                doc.setFontSize(9.5);
                let _legend_name = 1 > _fill_color_idx ? `: ${this.$t(legends_ko[_fill_color_idx], this.report_lang)},` : `: ${this.$t(legends_ko[_fill_color_idx], this.report_lang)}`;
                _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele);
                let _legend_name_dim = doc.getTextDimensions(_legend_name);
                
                doc.setFillColor(Object.values(_fill_color)[_fill_color_idx]);
                doc.rect(_longest_legend_position_x, position_y - 6.6, _legend_mark_width, _legend_name_dim.h, 'F');
                
                let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width + 2;
                doc.text(_legend_name, _legend_name_position_x, position_y);
                _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 8;
            });
            
            position_y += this.jsPDFOpt.spacing.section_xs;
            
            const mapQCodeToQName = {};
            this.scoringInfo.category3.forEach(category1 => {
                category1.category3.forEach(category3 => {
                    mapQCodeToQName[category3.category3_question_code] = category3;
                });
            });
            const _category3_group_left = JSON.parse(JSON.stringify(this.scoringInfo.category3.filter(({category1_question_name_ko}) => ['1. 인권 및 노동'].includes(category1_question_name_ko))));
            
            _category3_group_left[0].category3 = this.reportData.template_questions.reduce((acc, cur) => {
                if (!['1. 인권 및 노동'].includes(cur.category1_question_name))
                    return acc;
                acc.push({
                    ...cur,
                    category3_question_name: this.report_lang !== 'ko' ? cur.category3_question_name_ea ?? cur.category3_question_name : cur.category3_question_name,
                    ...mapQCodeToQName[cur.category3_question_code]
                });
                return acc;
            }, []);
            
            const _category3_group_right = JSON.parse(JSON.stringify(this.scoringInfo.category3.filter(({category1_question_name_ko}) => ['2. 윤리'].includes(category1_question_name_ko))));
            _category3_group_right[0].category3 = this.reportData.template_questions.reduce((acc, cur) => {
                if (!['2. 윤리'].includes(cur.category1_question_name))
                    return acc;
                acc.push({
                    ...cur,
                    category3_question_name: this.report_lang !== 'ko' ? cur.category3_question_name_ea ?? cur.category3_question_name : cur.category3_question_name,
                    ...mapQCodeToQName[cur.category3_question_code]
                });
                return acc;
            }, []);
            
            let _category3_group_left_postion_y = position_y;
            let _category3_group_right_postion_y = position_y;
            
            const returnCellFillColor = (below, na) => {
                const style = {};
                if (na) {
                    style.fillColor = _fill_color.na;
                } else if (below) {
                    style.fillColor = _fill_color.below;
                }
                return style;
            };
            
            const _category3_score_table_common_header = [{
                content: this.$t('세부 분류', this.report_lang), styles: {
                    ...this.tableStyles.th,
                    fontSize: this.report_lang === 'ko' ? 10 : 9.5,
                    cellPadding: {top: 5.5, right: 5, bottom: 1, left: 5}
                }
            }, {
                content: this.$t('충족률', this.report_lang), styles: {
                    ...this.tableStyles.th,
                    fontSize: this.report_lang === 'ko' ? 10 : 9.5,
                    cellPadding: {top: 5.5, right: 5, bottom: 1, left: 5}
                }
            },];
            
            const _category3_score_table_common_bodyStyle = {
                ...this.tableStyles.td,
                fontSize: this.report_lang === 'ko' ? 8.5 : 8,
                minCellHeight: 11,
                cellPadding: {top: 5, right: 5, bottom: 1.5, left: 5},
            };
            
            for (const _category3 of _category3_group_left) {
                const _category3_table_left = this.jsPDFOpt.margin.left;
                
                const {category1_question_name, category1_score} = _category3;
                _category3_group_left_postion_y = this.addTitle(doc, _category3_group_left_postion_y, 3, `${category1_question_name}:  ${category1_score}% `, {
                    skip_divider: true, no_margin: true
                });
                
                const _category3_score_table_body = _category3.category3.map(({
                    category3_question_name,
                    score,
                    below,
                    not_applicable
                }) => ([{
                    content: category3_question_name,
                    styles: {
                        ...returnCellFillColor(below, not_applicable), halign: 'left',
                        // fontSize: this.report_lang === 'ko' ? 8.5 : 7,
                        // cellWidth: this.pageContentWidth * 0.4
                    }
                }, {
                    content: not_applicable ? 'N/A' : (score != null ? score + '%' : 'Data'),
                    styles: returnCellFillColor(below, not_applicable),
                    // cellWidth: this.pageContentWidth * 0.1
                }]));
                
                _category3_score_table_body.unshift(_category3_score_table_common_header);
                
                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_left_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _category3_table_left},
                    styles: {...this.tableStyles.global, halign: 'center', valign: 'middle'},
                    bodyStyles: _category3_score_table_common_bodyStyle,
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });
                
                
                _category3_group_left_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            }
            
            const _category3_table_right = (this.pageContentWidth / 2) + 5 + this.jsPDFOpt.margin.left;
            for (const _category3 of _category3_group_right) {
                const {category1_question_name, category1_score} = _category3;
                let category1_question_name_score = `${category1_question_name}: ${category1_score}%`;
                _category3_group_right_postion_y = this.addTitle(doc, _category3_group_right_postion_y, 3, category1_question_name_score, {
                    skip_divider: true, no_margin: true, position_x: _category3_table_right
                });
                
                const _category3_score_table_body = _category3.category3.map(({
                    category3_question_name,
                    score,
                    below,
                    not_applicable
                }) => ([{
                    content: category3_question_name,
                    styles: {...returnCellFillColor(below, not_applicable), halign: 'left'}
                }, {
                    content: not_applicable ? 'N/A' : (score != null ? score + '%' : 'Data'),
                    styles: returnCellFillColor(below, not_applicable)
                }]));
                
                _category3_score_table_body.unshift(_category3_score_table_common_header);
                
                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_right_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _category3_table_right},
                    styles: {...this.tableStyles.global, halign: 'center', valign: 'middle'},
                    bodyStyles: _category3_score_table_common_bodyStyle,
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });
                
                _category3_group_right_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            }
            
            position_y = _category3_group_left_postion_y - 5;
            
            const guide_text_position_x = this.jsPDFOpt.margin.left;
            const guide_text_position_y = position_y;
            const guide_text = doc.splitTextToSize(`* Data: ${this.$t('법인 현황을 파악하기 위한 지표로 구성된 영역으로, 전체 충족률 산정에는 반영되지 않음', this.report_lang)}`, this.pageContentWidth + 100);
            
            this.setFont(doc, 'table_td', null, 'normal');
            doc.setTextColor(this.hyundai_colors.muted);
            doc.text(guide_text, guide_text_position_x, guide_text_position_y);
            
            return position_y;
        }, async generateCategory3AnalysisPage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc);
            position_y = this.firstElementSpacing;
            
            // 세부 영역별 평가 결과
            position_y = this.addTitle(doc, position_y, 1, '세부 영역별 평가 결과');
            
            // 세부 영역별 점수
            for (const [category3_idx, _category3] of this.scoringInfo.category3.entries()) {
                if (category3_idx > 0) {
                    doc.addPage();
                    this.addHeader(doc, 2);
                    position_y = this.firstElementSpacing;
                }
                
                const {category1_question_name, category1_question_name_ko} = _category3;
                
                position_y = this.addTitle(doc, position_y, 2, category1_question_name, {
                    skip_divider: true, no_padding: true
                }) - 5;
                position_y = this.addTitle(doc, position_y, 3, '영역별 평가 결과', {
                    skip_divider: true, no_margin: true, no_padding: true
                });
                
                
                // this.pageContentWidth: 386.46
                // this.jsPDFOpt.margin.left: 30
                // position_y: 96.25
                const _category3_score_box_padding = 5;
                const _category1_score_box_width = this.pageContentWidth; // 386.46 
                const _category1_score_box_half_position_y = this.jsPDFOpt.margin.left + ((this.pageContentWidth / 2) - _category3_score_box_padding);
                const _category1_score_box_half_width = ((this.pageContentWidth / 2) - _category3_score_box_padding);
                const _category1_score_box_height = 85; // 90 // 100
                const _category1_score_box_inner_position_y_begin = position_y + _category3_score_box_padding;
                const _category1_score_box_inner_position_y_end = _category1_score_box_inner_position_y_begin + _category1_score_box_height - (_category3_score_box_padding * 2);
                
                doc.setFillColor(...this.jsPDFOpt.card.fillColor);
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth * 2);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.rect(this.jsPDFOpt.margin.left, position_y, _category1_score_box_width, _category1_score_box_height, 'FD');
                
                
                // 좌우측 영역 구분 라인
                doc.setLineWidth(0.75);
                doc.setDrawColor('#E0E0E0');
                doc.line(_category1_score_box_half_position_y, _category1_score_box_inner_position_y_begin, _category1_score_box_half_position_y, _category1_score_box_inner_position_y_end);
                
                // Category1 타이틀
                const _category3_category1_question_name = doc.splitTextToSize(`${_category3.category1_question_name} ${this.$t('충족률', this.report_lang)}`, _category1_score_box_half_width - 10);
                const _category3_category1_question_name_dim = doc.getTextDimensions(_category3_category1_question_name);
                const _category3_category1_question_name_position_x = this.jsPDFOpt.margin.left + 10;
                const _category3_category1_question_name_position_y = _category1_score_box_inner_position_y_begin + (_category3_score_box_padding * 2);
                doc.text(_category3_category1_question_name, _category3_category1_question_name_position_x, _category3_category1_question_name_position_y);
                const _category3_category1_question_name_position_y_end = _category3_category1_question_name_position_y + _category3_category1_question_name_dim.h;
                
                // 좌측 영역
                doc.setFontSize(30);
                let _category3_category1_question_score = `${_category3.category1_score}%`;
                _category3_category1_question_score = doc.splitTextToSize(_category3_category1_question_score, _category1_score_box_half_width);
                const _category3_category1_question_score_dim = doc.getTextDimensions(_category3_category1_question_score);
                const _category3_category1_question_score_position_x = this.jsPDFOpt.margin.left + ((_category1_score_box_half_width - _category3_category1_question_score_dim.w) / 2);
                const _category3_category1_question_score_position_y = _category3_category1_question_name_position_y_end + ((_category1_score_box_inner_position_y_end - _category3_category1_question_name_position_y_end) / 2);
                doc.text(_category3_category1_question_score, _category3_category1_question_score_position_x, _category3_category1_question_score_position_y);
                
                // 우측 영역
                this.setFont(doc, 'table_td', null);
                doc.setFontSize(this.report_lang === 'en' ? 9 : 10.5);
                
                // 1. 우측 영역의 경계와 크기를 정의합니다.
                const _right_box_start_x = _category1_score_box_half_position_y;
                const _right_box_width = this.pageContentWidth / 2; // 혹은 _category1_score_box_width / 2
                const _right_box_height = _category1_score_box_height;
                const _right_box_padding_x = 10;
                
                // 2. 텍스트를 최대 너비에 맞게 나눕니다.
                const _category1_description_text = doc.splitTextToSize(
                    this.category1_description[category1_question_name_ko],
                    _right_box_width - (_right_box_padding_x * 2)
                );
                
                // 3. 나뉜 텍스트 블록의 전체 너비(w)와 높이(h)를 계산합니다.
                const text_block_dim = doc.getTextDimensions(_category1_description_text, {lineHeightFactor: 1.3});
                
                // 4. 텍스트를 상하좌우 정중앙에 배치하기 위한 X, Y 좌표를 계산합니다.
                // X 좌표: (박스 시작 x) + (박스 너비 - 텍스트 블록 너비) / 2
                const new_text_x = _right_box_start_x + ((_right_box_width - text_block_dim.w) / 2);
                
                // Y 좌표: (박스 시작 y) + (박스 높이 - 텍스트 블록 높이) / 2  (이 부분은 이전과 동일)
                const new_text_y = position_y + ((_right_box_height - text_block_dim.h) / 2) + 2;
                
                // 5. 계산된 위치에 align: 'left' 옵션으로 텍스트를 출력합니다.
                doc.text(
                    _category1_description_text,
                    new_text_x,
                    new_text_y,
                    {
                        align: 'left', // 텍스트 줄들은 왼쪽 정렬
                        lineHeightFactor: 1.3
                    }
                );
                
                position_y += _category1_score_box_height + this.jsPDFOpt.spacing.section_xs - 5;
                
                if (this.checkNeedNewPage(doc, position_y, 100)) {
                    position_y = this.firstElementSpacing;
                }
                
                
                position_y = this.addTitle(doc, position_y, 3, this.$t('세부 영역별 충족률', this.report_lang), {
                    skip_divider: true,
                    no_margin: true,
                });
                const y_axis_line_padding = 4.5;
                const _filtered_category3_score = _category3.category3.filter(({not_applicable}) => not_applicable === false);
                let _category3_score_chart_area_position_x_begin = this.jsPDFOpt.margin.left;
                let _category3_score_chart_area_position_x_end = this.jsPDFOpt.margin.left + this.pageContentWidth;
                let _category3_score_chart_width = _category3_score_chart_area_position_x_end - _category3_score_chart_area_position_x_begin;
                let _category3_score_chart_inner_width = _category3_score_chart_width - (y_axis_line_padding * 4);
                let _category3_score_chart_label_width = _category3_score_chart_inner_width * (this.report_lang === 'en' ? 0.5 : 0.35);
                let _category3_score_chart_label_position_x_begin = _category3_score_chart_area_position_x_begin + (y_axis_line_padding * 2);
                let _category3_score_chart_label_position_x_end = this.report_lang === 'en' ?
                    _category3_score_chart_area_position_x_begin + _category1_score_box_half_width - y_axis_line_padding :
                    _category3_score_chart_label_position_x_begin + _category3_score_chart_label_width - y_axis_line_padding;
                
                let _category3_score_chart_y_axis_position_x = _category3_score_chart_label_position_x_end + y_axis_line_padding;
                let _category3_score_chart_bar_area_width = (_category3_score_chart_inner_width * (this.report_lang === 'en' ? 0.5 : 0.65)) - (y_axis_line_padding * 4);
                let _category3_score_chart_bar_position_x_begin = _category3_score_chart_label_position_x_end + y_axis_line_padding;
                let _category3_score_chart_bar_thickness = 6;
                
                let _category3_score_label_total_height = _filtered_category3_score.reduce((_labels_total_height, {category3_question_name}) => {
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(9.5);
                    const _label = doc.splitTextToSize(category3_question_name, _category3_score_chart_label_width);
                    _labels_total_height += doc.getTextDimensions(_label).h / _label.length;
                    return _labels_total_height;
                }, 0);
                
                _category3_score_label_total_height += (_filtered_category3_score.length - 1) * (y_axis_line_padding * 2);
                
                let _category3_score_chart_area_height = _category3_score_label_total_height + (y_axis_line_padding * 2); // bar 시리즈에 위, 아래 패딩 추가
                let _category3_score_chart_height = _category3_score_chart_area_height + (y_axis_line_padding * 3); // 차트 내부 영역 - 높이에 위, 아래 패딩 추가
                let _category3_score_chart_position_y_begin = position_y;
                let _category3_score_chart_area_position_y_begin = _category3_score_chart_position_y_begin + y_axis_line_padding;
                let _category3_score_chart_area_position_y_end = _category3_score_chart_area_position_y_begin + _category3_score_chart_area_height + y_axis_line_padding;
                
                let _category3_bar_position_y = _category3_score_chart_area_position_y_begin + (y_axis_line_padding * 2.5);
                _filtered_category3_score.forEach(({category3_question_name, score, not_applicable}) => {
                    // label 추가
                    const _category3_barChart_label_dim = doc.getTextDimensions([category3_question_name]);
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(this.report_lang === 'en' ? 8 : 9.5);
                    
                    
                    doc.text(category3_question_name, _category3_score_chart_label_position_x_end, _category3_bar_position_y, {align: 'right'});
                    
                    
                    // score bar 추가
                    doc.setFillColor(...this.hyundai_colors_rgb.blue);
                    const _category3_barChart_bar_width = not_applicable ? 0 : (score / 100) * _category3_score_chart_bar_area_width;
                    const _category3_barChart_label_height = _category3_barChart_label_dim.h;
                    const _category3_barChart_bar_position_y = _category3_bar_position_y + (_category3_barChart_label_height - _category3_score_chart_bar_thickness) / 2 - y_axis_line_padding - 0.75;
                    const _category3_barChart_bar_position_x_end = _category3_score_chart_bar_position_x_begin + _category3_barChart_bar_width;
                    doc.rect(_category3_score_chart_bar_position_x_begin, _category3_barChart_bar_position_y, _category3_barChart_bar_width, _category3_score_chart_bar_thickness, 'F');
                    
                    // score 추가
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(9.5);
                    const _category3_barChart_score = doc.splitTextToSize(not_applicable ? 'N/A' : `${score}%`, 33);
                    const _category3_barChart_score_dim = doc.getTextDimensions(_category3_barChart_score);
                    doc.text(_category3_barChart_score, _category3_barChart_bar_position_x_end + y_axis_line_padding, _category3_barChart_bar_position_y + ((_category3_score_chart_bar_thickness + _category3_barChart_score_dim.h) / 2) - 1);
                    _category3_bar_position_y += (y_axis_line_padding * 2) + _category3_barChart_label_height;
                });
                
                // 라벨과 바의 분기 line
                doc.setLineWidth(0.35);
                doc.setDrawColor('#c8c8c8');
                doc.line(_category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_begin, _category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_end);
                
                // category3 bar 차트 Area
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.rect(_category3_score_chart_area_position_x_begin, _category3_score_chart_position_y_begin, _category3_score_chart_width, _category3_score_chart_height, 'D');
                
                
                position_y += _category3_score_chart_height + this.jsPDFOpt.spacing.section_md;
                if (this.checkNeedNewPage(doc, position_y, 40)) {
                    position_y = this.firstElementSpacing;
                }
                
                // 핵심지표 결과 테이블 범주
                let _longest_legend_position_x_weight = {ko: 28, en: 0, ca: 40};
                let legends_ko = ['충족', '미충족', '해당없음'];
                const _fill_color = {'충족': this.hyundai_colors.blue, '미충족': '#dc353c', '해당없음': '#BDBDBD'};
                let _category3_table_legend_ele = (this.pageContentWidth / 3);
                
                let _longest_legend_position_x = this.jsPDFOpt.margin.left + (this.pageContentWidth / 1.6) + _longest_legend_position_x_weight[this.report_lang];
                let _legend_mark_width = 7;
                let _legend_mark_position_y = position_y + 1;
                Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                    this.setFont(doc, 'table_td', null, 'normal');
                    doc.setFontSize(9);
                    let _legend_name = 2 > _fill_color_idx ? `${this.$t(legends_ko[_fill_color_idx], this.report_lang)}, ` : this.$t(legends_ko[_fill_color_idx], this.report_lang);
                    _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele);
                    let _legend_name_dim = doc.getTextDimensions(_legend_name);
                    
                    doc.setFillColor(Object.values(_fill_color)[_fill_color_idx]);
                    doc.circle(_longest_legend_position_x, _legend_mark_position_y, 3, 'F');
                    
                    let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width - 1;
                    doc.text(`: ${_legend_name}`, _legend_name_position_x, _legend_mark_position_y + 2);
                    _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 5;
                });
                
                position_y = this.addTitle(doc, position_y - 5, 3, this.$t('Core 지표 충족 여부', this.report_lang), {
                    skip_divider: true, no_margin: true
                });
                let _category1_key_indicator = this.scoring?.category1_importance_pd
                    .filter(({category1_question_code}) => category1_question_code === _category3.category1_question_code);
                _category1_key_indicator = _category1_key_indicator.reduce((_key_indicators, _key_indicator) => {
                    let {
                        category3_question_code,
                        category3_question_name,
                        category3_question_name_ca,
                        category3_question_name_ea,
                        sub_code,
                        level
                    } = _key_indicator;
                    
                    const target_sub_score = {
                        label: '',
                        score_msg: ''
                    };
                    this.mapSubCodeToScoringPd[sub_code].forEach(elem => {
                        const {
                            ev_name,
                            ev_name_e,
                            ev_name_c,
                            ev_reverse_name,
                            ev_reverse_name_e,
                            ev_reverse_name_c,
                            label,
                            satisfied
                        } = elem;
                        if (satisfied && ev_name) {
                            target_sub_score.score_msg = this.report_lang === 'ko' ? ev_name : this.report_lang === 'en' ? ev_name_e : ev_name_c;
                        } else if (!satisfied && ev_reverse_name) {
                            target_sub_score.score_msg = this.report_lang === 'ko' ? ev_reverse_name : this.report_lang === 'en' ? ev_reverse_name_e : ev_reverse_name_c;
                        }
                        target_sub_score.label = label;
                    });
                    
                    let _category3_question_name = this.report_lang === 'ko' ? category3_question_name : this.report_lang === 'ca' ? category3_question_name_ca : category3_question_name_ea;
                    
                    
                    if (!_key_indicators[category3_question_code]) {
                        _key_indicators[category3_question_code] = {
                            category3_question_name: _category3_question_name, count: 0, indicators: []
                        };
                    }
                    
                    _key_indicators[category3_question_code].count++;
                    _key_indicators[category3_question_code].indicators.push({
                        sub_label: target_sub_score.label,
                        score_msg: !level ? '-' : target_sub_score.score_msg,
                        level: !level ? 'N/A' : level
                    });
                    
                    return _key_indicators;
                }, {});
                _category1_key_indicator = Object.values(_category1_key_indicator);
                
                // 핵심지표 결과 테이블
                const category1_key_indicator_header = [[
                    {
                        content: this.$t('번호', this.report_lang),
                        styles: {cellWidth: this.pageContentWidth * 0.1}
                    },
                    {content: this.$t('현황', this.report_lang), styles: {cellWidth: this.pageContentWidth * 0.1}},
                    {
                        content: this.$t('내용', this.report_lang),
                        styles: {cellWidth: this.pageContentWidth * 0.8}
                    },
                ]];
                let category1_key_indicators = _category1_key_indicator.reduce((_key_indicator_rows, _key_indicator_ele) => {
                    const {indicators} = _key_indicator_ele;
                    indicators.forEach(({sub_label, score_msg, level}) => {
                        const _indicator_style = {...this.tableStyles.td};
                        if (level === null || level === 'N/A') {
                            _indicator_style.textColor = _fill_color['해당없음'];
                        } else if (level === 'full') {
                            _indicator_style.textColor = _fill_color['충족'];
                        } else {
                            _indicator_style.textColor = _fill_color['미충족'];
                        }
                        
                        let _indicator_row = [
                            {content: sub_label, styles: this.tableStyles.td},
                            {
                                content: level === null ? 'N/A' : '●', styles: _indicator_style
                            },
                            {
                                content: level === null ? '-' : score_msg,
                                styles: {...this.tableStyles.td, halign: 'left'}
                            },
                        
                        ];
                        
                        _key_indicator_rows.push(_indicator_row);
                    });
                    
                    return _key_indicator_rows;
                }, []);
                
                if (!category1_key_indicators.length) {
                    category1_key_indicators = [[{
                        content: this.$t('해당사항 없음', this.report_lang), colSpan: 4, styles: this.tableStyles.td
                    }]];
                }
                
                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: this.pageContentWidth,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: this.jsPDFOpt.margin.left},
                    styles: {...this.tableStyles.global, halign: 'center'},
                    headStyles: this.tableStyles.th,
                    head: category1_key_indicator_header,
                    body: category1_key_indicators,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });
                
                position_y = doc.lastAutoTable.finalY + 10;
                
                const guide_text_position_x = this.jsPDFOpt.margin.left;
                const guide_text = doc.splitTextToSize(`* ${this.$t('Core 지표: 다른 지표에 비해 중요도가 높은 항목으로, 미충족 시 즉시 시정조치가 요구되며, 정기적인 평가를 통해 지속적으로 모니터링 대상이 됨', this.report_lang)}`, this.pageContentWidth + 120);
                this.setFont(doc, 'table_td', null, 'normal');
                doc.setTextColor(this.hyundai_colors.muted);
                doc.text(guide_text, guide_text_position_x, position_y);
                position_y += this.jsPDFOpt.spacing.section_xs;
            }
            
            
            if (this.checkNeedNewPage(doc, position_y, 100)) {
                position_y = this.firstElementSpacing;
            }
            
            return position_y;
        }, createFactorsPage(doc, position_y) {
            try {
                let _is_new_page = this.checkNeedNewPage(doc, position_y, this.pageContentHeight / 2); // 35
                if (_is_new_page) {
                    position_y = this.firstElementSpacing;
                }
                
                position_y = this.addTitle(doc, position_y, 1, this.$t('세부 평가결과', this.report_lang));
                
                this.factors.forEach((_cat1, _cat1_idx) => {
                    if (_cat1_idx > 0 && _cat1_idx < this.factors.length) {
                        position_y += this.jsPDFOpt.spacing.section_sm;
                    }
                    
                    
                    let _is_new_page = this.checkNeedNewPage(doc, position_y, 40); // 35
                    if (_is_new_page) {
                        position_y = this.firstElementSpacing;
                    }
                    
                    position_y = this.addTitle(doc, position_y, 2, `${this.$t(_cat1.category1_question_name, this.report_lang)}`, {
                        skip_divider: true, no_padding: true, no_margin: true
                    });
                    
                    _cat1.category3.forEach((_cat3) => {
                        // 문항별 Factors 테이블
                        _cat3.subs.forEach((_sub) => {
                            let _is_new_page = this.checkNeedNewPage(doc, position_y, 40); // 80 // 50 // 35
                            if (_is_new_page) {
                                position_y = this.firstElementSpacing;
                            }
                            
                            let _factor_table_title = `[${_cat3.category3_question_name} - ${_sub.sub_code}]`;
                            if (_sub.sub_name) {
                                _factor_table_title += ` ${_sub.sub_name}`;
                            }
                            position_y = this.addTitle(doc, position_y, 4, _factor_table_title, {
                                skip_divider: true, no_margin: true, no_padding: true
                            });
                            position_y -= 3;
                            const _flatten_sub_evaluations = [..._sub.evaluations].reduce((_flatten, _sub_ev) => {
                                _flatten.push(..._sub_ev);
                                return _flatten;
                            }, []);
                            
                            const _has_importance_evaluation_or_assessment = !!_flatten_sub_evaluations.find(({contentType}) => ['importance', 'assessment'].includes(contentType));
                            const _columnStyles = {
                                0: {
                                    cellWidth: this.report_lang === 'ko' ? this.pageContentWidth * 0.1 : this.pageContentWidth * 0.15,
                                    halign: 'center',
                                }
                            };
                            
                            if (_has_importance_evaluation_or_assessment) {
                                _columnStyles[1] = {
                                    ...this.tableStyles.td,
                                    cellWidth: this.report_lang !== 'ko' ? this.pageContentWidth * 0.17 : this.pageContentWidth * 0.12,
                                    valign: 'middle',
                                    halign: 'left'
                                };
                            }
                            
                            autoTable(doc, {
                                theme: 'grid',
                                startY: position_y,
                                useCss: true,
                                margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5},
                                body: _sub.evaluations,
                                rowPageBreak: 'avoid',
                                head: [[{content: this.$t('충족 여부', this.report_lang), dataKey: 'FactorState'}, {
                                    content: this.$t('주요 사항', this.report_lang),
                                    dataKey: 'FactorContent',
                                    colSpan: (_has_importance_evaluation_or_assessment) ? 2 : 1
                                }]],
                                styles: this.factorstables.global,
                                headStyles: this.factorstables.th,
                                bodyStyles: this.factorstables.td,
                                columnStyles: _columnStyles,
                                willDrawCell: (data) => {
                                    if (data.section === 'body') {
                                        const {cell} = data;
                                        if (data.column.dataKey === 0) {
                                            cell.text = [];
                                        } else if (data.column.dataKey === 1) {
                                            if (cell.raw.contentType === 'importance' && cell.raw.content) {
                                                cell.text = [];
                                            } else {
                                                cell.styles.cellPadding.right = 6.5;
                                                cell.styles.cellPadding.left = 6.5;
                                            }
                                        }
                                    }
                                },
                                didDrawCell: (data) => {
                                    if (data.section === 'body') {
                                        const {column, cell, doc} = data;
                                        if (column.dataKey === 0) {
                                            const textColor = '#ffffff';
                                            const _text = cell.raw.content;
                                            const bgColor = cell.raw.status ? '#2196f3' : '#ff5722';
                                            if (this.report_lang === 'ca') {
                                                cell.styles.font = this.jsPDFOpt.fontFamily_ca;
                                            } else {
                                                cell.styles.font = this.jsPDFOpt.fontFamily;
                                            }
                                            
                                            // Set text color
                                            doc.setTextColor(textColor);
                                            doc.setFontSize(cell.styles.fontSize - 1.2);
                                            doc.setFillColor(bgColor);
                                            
                                            const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h];
                                            let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5];
                                            if (badgeWidth >= cell.width) {
                                                badgeWidth += textWidth + 3;
                                            }
                                            
                                            if (this.pageContentHeight >= cell.y + 1) {
                                                doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F');
                                                
                                                // Draw text in the center of the cell
                                                doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                    baseline: 'middle', align: 'center'
                                                });
                                            }
                                        } else if (column.dataKey === 1) {
                                            if (cell.raw.contentType === 'importance' && cell.raw.content) {
                                                // Set text color
                                                doc.setTextColor('#ffffff');
                                                doc.setFontSize(this.report_lang === 'ko' ? cell.styles.fontSize - 1.5 : cell.styles.fontSize - 2);
                                                doc.setFillColor('#1565C0');
                                                
                                                const _text = cell.raw.content;
                                                const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h];
                                                let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5];
                                                if (badgeWidth >= cell.width) {
                                                    badgeWidth += textWidth + 3;
                                                }
                                                
                                                doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F');
                                                
                                                // Draw text in the center of the cell
                                                doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                    baseline: 'middle', align: 'center'
                                                });
                                                
                                            } else if (cell.raw.contentType === 'content' && cell.raw.content) {
                                                if (this.report_lang === 'ca') {
                                                    cell.styles.font = this.jsPDFOpt.fontFamily_ca;
                                                } else {
                                                    cell.styles.font = this.jsPDFOpt.fontFamily;
                                                }
                                            }
                                        }
                                    }
                                },
                                didDrawPage: (HookData) => {
                                    this.addHeader(HookData.doc);
                                }
                            });
                            
                            this.setFont(doc, null);
                            position_y = doc.lastAutoTable.finalY;
                            
                            // // 문항별 실사의견 테이블
                            // if (_sub.sub_review_comment && /^[\s\W]*$/.test(_sub.sub_review_comment) === false) {
                            //     autoTable(doc, {
                            //         theme: 'grid',
                            //         startY: position_y,
                            //         useCss: true,
                            //         margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5 },
                            //         styles: { valign: 'middle' },
                            //         body: [
                            //             [
                            //                 {
                            //                     content: this.$t('평가자 종합 의견', this.report_lang),
                            //                     styles: {
                            //                         ...this.tableStyles.th,
                            //                         fontSize: this.report_lang === "ca" ? 7.8 : 8.5,
                            //                         cellWidth: this.report_lang === "ko" ? 38.7 : 58,
                            //                         halign: 'center',
                            //                         cellPadding: { top: 4, right: 5, bottom: 3.5, left: 5 },
                            //                     }
                            //                 },
                            //                 {
                            //                     content: _sub.sub_review_comment,
                            //                     styles: {
                            //                         ...this.tableStyles.td,
                            //                         cellPadding: { top: 4.5, right: 5, bottom: 3.5, left: 5 }
                            //                     }
                            //                 },
                            //             ]
                            //         ]
                            //     })
                            
                            //     position_y = doc.lastAutoTable.finalY
                            // }
                            
                            position_y += this.jsPDFOpt.spacing.section_xs;
                        });
                    });
                });
                
                return position_y;
            } catch (error) {
                console.log(error);
                
            }
            
        }, generateFactors() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                this.factors = [];
            } else {
                let _scoring_pd = this.sortBySubCode([...this.scoring.scoring_pd.sort((a, b) => {
                    return a.satisfied && !b.satisfied ? -1 : !a.satisfied && b.satisfied ? 1 : 0;
                })]);
                _scoring_pd = _scoring_pd.sort((a, b) => {
                    return a.ev_id > b.ev_id;
                });
                
                const _lang = this.report_lang;
                
                const mapSubToScoring = {};
                const mapSubToSubScoring = {};
                
                this.scoring.sub_scoring_pd.forEach(elem => {
                    mapSubToSubScoring[elem.sub_code] = elem;
                });
                
                let _factors_raw = _scoring_pd.reduce((_factors_v2, _factor) => {
                    if (mapSubToScoring[_factor.sub_code] == null) {
                        mapSubToScoring[_factor.sub_code] = [];
                    }
                    mapSubToScoring[_factor.sub_code].push(_factor);
                    if (!_factor.not_applicable && _factor.sub_code) {
                        let {
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ea,
                            category1_question_name_ca,
                            category3_question_code,
                            category3_question_name,
                            category3_question_name_ea,
                            category3_question_name_ca,
                            sub_code,
                            sub_name,
                            sub_name_ca,
                            sub_name_ea,
                            satisfied,
                            ev_name,
                            ev_name_e,
                            ev_name_c,
                            ev_reverse_name,
                            ev_reverse_name_e,
                            ev_reverse_name_c,
                            ev_importance,
                        } = _factor;
                        
                        let _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code);
                        const _category1_question_name = _lang === 'ko' ? category1_question_name : _lang === 'en' ? category1_question_name_ea : category1_question_name_ca;
                        if (_category1_idx < 0) {
                            _factors_v2.push({
                                category1_question_code,
                                category1_question_name: _category1_question_name,
                                category3: []
                            });
                            
                            _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code);
                        }
                        
                        let _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code);
                        if (_category3_idex < 0) {
                            const _category3_question_name = _lang === 'ko' ? category3_question_name : _lang === 'en' ? category3_question_name_ea : category3_question_name_ca;
                            _factors_v2[_category1_idx].category3.push({
                                category3_question_code, category3_question_name: _category3_question_name, subs: []
                            });
                            
                            _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code);
                        }
                        
                        let [_content_ev, , _sub_name, // _content_audit_comment, _content_review_comment
                        ] = new Array(4).fill(null);
                        if (satisfied) {
                            _content_ev = _lang === 'ko' ? ev_name : _lang === 'en' ? ev_name_e : ev_name_c;
                        } else {
                            _content_ev = _lang === 'ko' ? ev_reverse_name : _lang === 'en' ? ev_reverse_name_e : ev_reverse_name_c;
                        }
                        // _content_audit_comment = _lang === "ko" ? audit_comment : _lang === "en" ? audit_comment_ea : audit_comment_ca
                        // _content_review_comment = _lang === "ko" ? review_comment : _lang === "en" ? review_comment_ea : review_comment_ca
                        
                        if (!_content_ev) _content_ev = null;
                        // if (!_content_audit_comment) _content_audit_comment = null
                        // if (!_content_review_comment) _content_review_comment = null
                        
                        _sub_name = _lang === 'ko' ? sub_name : _lang === 'en' ? sub_name_ea : sub_name_ca;
                        if (!_sub_name) _sub_name = null;
                        // if (_content_review_comment && /^[^\p{L}\p{N}]+$/u.test(_content_review_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_review_comment)) {
                        //         _content_review_comment = _content_review_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_review_comment = this.isFieldEmpty(_content_review_comment) ? null : _content_review_comment
                        
                        let _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex((sub) => sub.sub_code === sub_code);
                        if (_sub_index === -1) {
                            _factors_v2[_category1_idx].category3[_category3_idex].subs.push({
                                sub_code, sub_name: _sub_name, evaluations: [], sub_review_comment: null // _content_review_comment
                            });
                            
                            _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex(({sub_code: _sub_code}) => _sub_code === sub_code);
                        }
                        
                        // if (_content_audit_comment && /^[^\p{L}\p{N}]+$/u.test(_content_audit_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_audit_comment)) {
                        //         _content_audit_comment = _content_audit_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_audit_comment = this.isFieldEmpty(_content_audit_comment) ? null : _content_audit_comment
                        
                        if (_content_ev && /^[^\p{L}\p{N}]+$/u.test(_content_ev) === false) {
                            let _evaluation_content = [];
                            const _row_1st = [{
                                content: satisfied ? this.$t('충족', this.report_lang) : this.$t('미충족', this.report_lang),
                                contentType: 'satisfied', // rowSpan: !_content_audit_comment ? 1 : 2,
                                rowSpan: 1,
                                status: satisfied,
                                styles: {}
                            }];
                            if (ev_importance === 'HIGH') {
                                _row_1st.push({
                                    content: this.$t('중요사항', this.report_lang),
                                    contentType: 'importance',
                                    styles: {halign: 'center', valign: 'middle', fillColor: 248}
                                });
                            }
                            _row_1st.push({
                                content: _content_ev, contentType: 'content', styles: this.factorstables.td
                            });
                            _evaluation_content.push(_row_1st);
                            
                            // if (_content_audit_comment) {
                            //     _evaluation_content.push([
                            //         { content: this.$t('항목별 평가자 의견', this.report_lang), styles: { halign: "center", valign: "middle", fillColor: 248, fontSize: this.report_lang === "en" ? this.factorstables.td.fontSize - 0.3 : this.factorstables.td.fontSize } },
                            //         { content: _content_audit_comment, contentType: "assessment" }
                            //     ])
                            // }
                            
                            _factors_v2[_category1_idx].category3[_category3_idex].subs[_sub_index].evaluations.push(..._evaluation_content);
                        }
                    }
                    
                    return _factors_v2;
                }, []);
                
                for (let _factor_cat1 of _factors_raw) {
                    for (let _factor_cat3 of _factor_cat1.category3) {
                        for (let _factor_subs of _factor_cat3.subs) {
                            const _flatten_sub_evaluations = [..._factor_subs.evaluations].reduce((_flatten, _sub_ev) => {
                                _flatten.push(..._sub_ev);
                                return _flatten;
                            }, []);
                            
                            const _has_importance_evaluation_or_assessment = _flatten_sub_evaluations.some(({contentType}) => ['importance', 'assessment'].includes(contentType));
                            if (_has_importance_evaluation_or_assessment) {
                                for (let _subs_evs of _factor_subs.evaluations) {
                                    let _ev_importance_or_assessment_idx = _subs_evs.findIndex(({contentType}) => contentType && ['importance', 'assessment'].includes(contentType));
                                    if (_ev_importance_or_assessment_idx == -1) {
                                        const _subs_evs_idx = _subs_evs.findIndex(({contentType}) => contentType === 'content');
                                        if (_subs_evs_idx !== -1) {
                                            _subs_evs[_subs_evs_idx].colSpan = 2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                
                this.factors = _factors_raw;
                this.mapSubCodeToScoringPd = mapSubToScoring;
                this.mapSubCodeToSubScoringPd = mapSubToSubScoring;
            }
        },
        orderCategory1(_category1_scoring, _category1_fieldname) {
            if (!Array.isArray(_category1_scoring)) {
                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = Object.values(_category1_scoring).find(_category1 => _category1[_category1_fieldname] === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            } else {
                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = _category1_scoring.find(_category1 => _category1[_category1_fieldname] === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            }
        },
        async generatePDF_hyundai(doc, position_top) {
            if (this.reportMode === 'full') {
                // Factors 페이지 데이터 생성
                this.generateFactors();
            }
            this.pageContentWidth = doc.internal.pageSize.width - (this.jsPDFOpt.margin.left + this.jsPDFOpt.margin.right);
            this.pageContentHeight = doc.internal.pageSize.height - (this.jsPDFOpt.margin.top + this.jsPDFOpt.margin.bottom);
            
            this.generateCover_hyundai(doc);
            
            doc.addPage();
            this.addHeader(doc, 2);
            
            let position_y = await this.createSummaryPage(doc, position_top);
            position_y = this.generatePartialSummaryPage(doc, position_y);
            position_y = await this.createCategory2ScorePage(doc, position_y);
            position_y = await this.generateCategory3AnalysisPage(doc, position_y);
            
            
            const end_of_document_x = doc.internal.pageSize.getWidth() / 2;
            const end_of_document_y = doc.internal.pageSize.getHeight() - 50;
            
            this.setFont(doc, 'title_sm', null, 'normal');
            doc.setTextColor(this.hyundai_colors.muted);
            doc.text('- End of Document -', end_of_document_x, end_of_document_y, {
                align: 'center'
            });
            
            
            const totalPages = doc.getNumberOfPages();
            
            for (let i = 2; i <= totalPages; i++) {
                doc.setPage(i);  // 현재 페이지로 이동
                this.addFooter(doc);
            }
            
            doc.setDocumentProperties({
                title: this.pdf_filename,
                subject: this.pdf_filename,
                filename: `${this.pdf_filename}.pdf`,
                author: 'QuantifiedESG Inc.',
                creator: 'QESG'
            });
            
            return doc;
        },
        generateCover_hyundai(doc) {
            try {
                // 페이지 너비,높이
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                
                const maxWidth = pageWidth - 20; // 페이지의 여백을 고려한 너비
                const maxHeight = pageHeight - 20; // 페이지의 여백을 고려한 높이
                
                // 표지 색상 설정
                doc.setFillColor(this.hyundai_colors.blue); // RGB 값
                doc.rect(0, 0, pageWidth, pageHeight, 'F'); // 'F'는 fill
                
                const cover_hyundai_logo_position_x = 30;
                const cover_hyundai_logo_position_y = 40;
                
                // 현대 로고 추가
                doc.addImage(this.hyundai_logo_png, 'png', cover_hyundai_logo_position_x, cover_hyundai_logo_position_y, this.hyundai_logo_white.width * 1.4, this.hyundai_logo_white.height * 1.4);
                
                // 보고서 이름 추가
                this.setFont(doc, 'cover_name_lg');
                const [_report_title_width, _report_title_height] = [doc.getTextDimensions(this.cover_title).w, doc.getTextDimensions(this.cover_title).h];
                
                let _text_position_x = this.jsPDFOpt.margin.left;
                
                let _text_position_y = (maxHeight / 3) + (this.jsPDFOpt.margin.top * 1.25);
                doc.setTextColor('#FFFFFF');
                doc.text(this.cover_title, _text_position_x, _text_position_y, {});
                
                // 보고서 기업명 추가
                if (this.report_lang === 'ca' && this.isChineseOrHanzi(this.companyInfo['회사명'])) {
                    this.setFont(doc, 'cover_company_name', this.jsPDFOpt.fontFamily_ca);
                } else {
                    doc.setFont();
                    this.setFont(doc, 'cover_company_name', this.jsPDFOpt.fontFamily);
                }
                
                const _company_name = doc.splitTextToSize(this.companyInfo['회사명'], this.pageContentWidth);
                _text_position_y += _report_title_height + (this.jsPDFOpt.margin.top * 0.75);
                doc.setTextColor('#FFFFFF');
                doc.text(_company_name, _text_position_x, _text_position_y);
                
                // disclaimer 추가
                /**
                 * 969696
                 */
                this.setFont(doc, 'title_sm', this.jsPDFOpt.fontFamily);
                doc.setTextColor('#FFFFFF');
                doc.text('Disclaimer', 30, maxHeight - 65, {});
                
                doc.setDrawColor('#FFFFFF'); // RGB 값
                doc.setLineWidth(0.5);                // 굵은 선
                doc.line(28, maxHeight - 60, this.report_lang === 'en' ? 300 : 280, maxHeight - 60); // 좌측 20~우측 190, y=40 위치에 가로선
                
                const texts = [
                    `- ${this.$t('result_report_disclaimer.text1', this.report_lang)}`,
                    `   ${this.$t('result_report_disclaimer.text2', this.report_lang)}`,
                    `- ${this.$t('result_report_disclaimer.text3', this.report_lang)}`,
                    `   ${this.$t('result_report_disclaimer.text4', this.report_lang)}`,
                    `- ${this.$t('result_report_disclaimer.text5', this.report_lang)}`,
                ];
                
                // 각 줄별로 출력 (들여쓰기 반영)
                const lineHeight = 9;
                const leftMargin = 30;
                let y = maxHeight - 50; // 시작 위치
                texts.forEach((line, idx) => {
                    
                    this.setFont(doc, 'footnote', this.jsPDFOpt.fontFamily);
                    doc.setTextColor('#FFFFFF');
                    doc.text(line, leftMargin, y);
                    y += lineHeight;
                });
            } catch (error) {
                console.log(error);
            }
        }, 
        addHeader(doc) {
            doc.setFillColor(this.hyundai_colors.blue);
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(this.jsPDFOpt.headerStyles.fontSize);
            doc.setTextColor(...this.jsPDFOpt.headerStyles.textColor);
            const [headerBox_position_x, headerBox_position_y] = [this.jsPDFOpt.margin.left, this.jsPDFOpt.margin.top + 10];
            doc.rect(headerBox_position_x, headerBox_position_y, this.pageContentWidth, this.jsPDFOpt.headerHeight, 'F');
            
            const report_header_padding = 10;
            let _report_serial_number = this.formatDate(new Date().toUTCString(), 'YYMMDD');
            _report_serial_number += `-${this.reportData.info.company_id}`;
            _report_serial_number += `-${this.reportData.info.id}`;
            
            _report_serial_number = doc.splitTextToSize(`${this.$t('발급번호', this.report_lang)} : ${_report_serial_number}`, this.pageContentWidth / 2);
            const _report_serial_number_dim = doc.getTextDimensions(_report_serial_number);
            const _report_serial_number_position_y = headerBox_position_y + ((this.jsPDFOpt.headerHeight - _report_serial_number_dim.h)) - 1;
            doc.text(_report_serial_number, headerBox_position_x + report_header_padding, _report_serial_number_position_y);
            
            const _report_company_header = doc.splitTextToSize(this.companyInfo['회사명'], doc.getTextWidth(this.companyInfo['회사명'] ?? '') + 10);
            const _report_company_header_dim = doc.getTextDimensions(_report_company_header);
            const _report_company_header_position_x = this.jsPDFOpt.margin.left + this.pageContentWidth - doc.getTextWidth(this.companyInfo['회사명'] ?? '') - report_header_padding;
            const _report_company_header_position_y = headerBox_position_y + ((this.jsPDFOpt.headerHeight - _report_company_header_dim.h)) - 1;
            
            if (this.report_lang === 'ca' && this.isChineseOrHanzi(this.companyInfo['회사명'])) {
                this.setFont(doc, null, this.jsPDFOpt.fontFamily_ca);
            } else {
                this.setFont(doc, null, this.jsPDFOpt.fontFamily);
            }
            
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(this.jsPDFOpt.headerStyles.fontSize);
            doc.setTextColor(...this.jsPDFOpt.headerStyles.textColor);
            doc.text(_report_company_header, _report_company_header_position_x, _report_company_header_position_y);
        }, addFooter(doc) {
            // this.setFont(doc)
            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(this.jsPDFOpt.footerStyles.fontSize);
            doc.setFillColor(this.hyundai_colors.sand);
            
            const pageHeight = doc.internal.pageSize.getHeight();
            const [footerBox_position_x, footerBox_position_y] = [0, pageHeight - this.jsPDFOpt.footerHeight];
            const footerBox_width = doc.internal.pageSize.getWidth();
            doc.rect(footerBox_position_x, footerBox_position_y, footerBox_width, this.jsPDFOpt.footerHeight, 'F');
            
            // const _page_total = doc.internal.getNumberOfPages();
            const _page_total = doc.getNumberOfPages() - 1;
            const _page_current = doc.getCurrentPageInfo().pageNumber;
            
            // (좌측) Hyundai 로고
            const logo_hyundai_position_y = pageHeight - (this.jsPDFOpt.footerHeight / 2) - 20;
            doc.addImage(this.hyundai_logo_blue_png, 'png', this.jsPDFOpt.margin.left, logo_hyundai_position_y, this.hyundai_logo_blue.width * 0.9, this.hyundai_logo_blue.height * 0.9);
            const desc_position_x = this.jsPDFOpt.margin.left + (this.hyundai_logo_blue.width * 0.9) + 5;
            const desc_position_y = logo_hyundai_position_y + 23;
            doc.setFontSize(9);
            doc.setTextColor(this.hyundai_colors.gray);
            doc.text(this.$t('QESG 평가 수행', this.report_lang), desc_position_x, desc_position_y);
            // (우측) 페이지 넘버
            doc.setTextColor('#333333');
            doc.setFontSize(10);
            const _footer_pages = doc.splitTextToSize(`${_page_current - 1} / ${_page_total}`, footerBox_width - this.jsPDFOpt.margin.right);
            const _footer_pages_height = doc.getTextDimensions(_footer_pages).h;
            const _footer_pages_width = doc.getTextDimensions(_footer_pages).w;
            const _footer_pages_position_x = footerBox_width - _footer_pages_width - (this.jsPDFOpt.margin.left);
            const _footer_pages_position_y = footerBox_position_y + (this.jsPDFOpt.footerHeight / 2) + (_footer_pages_height / 2);
            doc.text(_footer_pages, _footer_pages_position_x, _footer_pages_position_y);
        },
        
        drawScoreIndicator_hyundai(doc, x, y, score, opt = {}) {
            // 기본 옵션 설정
            if (typeof opt.label_position === 'undefined') {
                opt.label_position = 'top';
            }
            if (typeof opt.indicator_fill_color === 'undefined') {
                opt.indicator_fill_color = [0, 76, 153];
            }
            if (typeof opt.indicator_border_color === 'undefined') {
                opt.indicator_border_color = [0, 76, 153];
            }
            if (typeof opt.indicator_line_style === 'undefined') {
                opt.indicator_line_style = 'solid'; // 'solid', 'dashed_border_only'
            }
            if (typeof opt.label_font_size === 'undefined') {
                opt.label_font_size = 9.5;
            }
            if (typeof opt.size === 'undefined') {
                opt.size = 3; // 원의 반지름으로 사용될 크기
            }
            
            const radius = opt.size; // 원의 반지름
            
            doc.setLineWidth(1); // 원의 테두리 두께
            
            // 선 스타일 설정 (점선 또는 실선)
            if (opt.indicator_line_style === 'dashed_border_only') {
                doc.setLineDash([2, 1], 0); // 점선 설정
                doc.setFillColor(255, 255, 255, 0); // 투명 채움 색상
                doc.setDrawColor(...opt.indicator_border_color); // 테두리 색상
                // 채움 색상은 설정하지 않음 (투명)
                doc.circle(x, y, radius, 'S'); // 테두리만 있는 원 ('S' = Stroke)
            } else { // 'solid' 또는 기본값
                doc.setLineDash([], 0); // 실선 설정 (점선 해제)
                doc.setDrawColor(...opt.indicator_border_color); // 테두리 색상
                doc.setFillColor(...opt.indicator_fill_color); // 채움 색상
                doc.circle(x, y, radius, 'FD'); // 채우고 테두리 있는 원 ('FD' = Fill and Draw)
            }
            
            // 텍스트 (스코어) 출력
            const scoreStr = String(score); // score가 숫자일 수 있으므로 문자열로 변환
            const textDims = doc.getTextDimensions(scoreStr, {fontSize: opt.label_font_size});
            const textX = x - textDims.w / 2;
            let textY = y; // 기본 Y 위치
            
            
            if (opt.label_position === 'bottom') {
                textY = y + radius + 4 + (textDims.h / 2); // 원 아래에 위치, 텍스트 높이 고려
            } else if (opt.label_position === 'top') {
                textY = y - radius - 2; // 원 위에 위치
            }
            if (opt.label_y_position) {
                textY += opt.label_y_position;
            }
            doc.setFontSize(opt.label_font_size);
            doc.setTextColor(0); // 텍스트 색상 (검정)
            if(score === 'N/A'){
                doc.text(score, textX, textY);
            }
            else{
                doc.text(`${scoreStr}%`, textX, textY);
            }
            
            // 다음 도형에 영향을 주지 않도록 선 스타일 초기화
            doc.setLineDash([], 0);
            doc.setLineWidth(1); // 기본 선 두께로 복원 (필요하다면)
        },
    }
};
